import React, { useEffect } from 'react';
import styles from './windowAuction.module.css';

import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {createBodyOld} from '../createBodyPostAndPatch/createBodyAuction'
import {createBody} from '../../createAuction/procedure/lib/createBody'

import {
    getMyAuction,
    changeCreateAuctionTitle,
    changeCreateAuctionDescription,
    changeCreateAuctionType,
    changeCreateAuctionTenderAttempts,
    changeCreateAuctionAccessDetails,
    changeCreateAuctionXDocumentRequirements,
    changeCreateAuctionXAdditionalInformation,
    changeCreateAuctionValueCurrency,
    changeCreateAuctionValueAmount,
    changeCreateAuctionValueTax,
    changeCreateAuctionGuaranteeCurrency,
    changeCreateAuctionGuaranteeAmount,
    changeCreateAuctionGuaranteeTax,
    changeCreateAuctionMinimalStepCurrency,
    changeCreateAuctionMinimalStepAmount,
    changeCreateAuctionMinimalStepTax,
    changeCreateAuctionDateStart,
    changeCreateAuctionDateEnd,
    changeCreateAuctionLotIdentifier,
    changeCreateAuctionTab,
    setCarryType,
    minNumberOfQualifiedBids,
    changeCreateAuctionMinNumberOfQualifiedBids,
    changeCreateAuctionDgfVirtualDataRoom,
    changeCreateAuctionDgfEligibilityCriteria,
    changeCreateAuctionDgfX_dgfPlatformLegalDetails,
    changeCreateAuctionDgfDecisionId,
    changeCreateAuctionDgfDecisionDate,
} from '../../../../../redux/actions.js';

import {
    changeLoader,
} from '../../../../../redux/actions.js';

import {
    changeAuctionsSwitchWindow,
    auctionsGetMy,
    setPopUpAuctionCreate,
    setPopUpAuctionMyNull,
} from '../../../../../redux/actions/auctions/auctions.js';

import {
    setDataAddress,
} from '../../../../../redux/createAddress';

import {
    changePopUpBankAccount,
    setPopBankAccountId,
    setPopBankAccountIdArr,
    setBankAccountSave,
    setBankAccountAdd,
    setBankAccountDelete,
    openBankWindows,
} from '../../../../../redux/actions/bankAccount/bankAccount.js';

import {
    changeCreateItemGeologivDataValue,
    changeCreateItemDocumentationValue,
    changeCreateItemDateUse
} from '../../../../../redux/actions/auctionItems/auctionItems.js';

import {
    changeDiscountPercent,
    changeDiscountPreviousAuctionCurrency,
    changeDiscountPreviousAuctionAmount,
    changeDiscountPreviousAuctionId,
    discountAuc,
} from '../../../../../redux/actions/discount/discount.js';

import {setUniversalError} from '../../../../../redux/actions.js';

/////////////////////////////////////
import 'date-fns';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import WindowAuctionSelfNumber from '../../windowAuctionSelfNumber.js';
import WindowAuctionTitle from '../../windowAuctionTitle.js';
import WindowAuctionDescription from '../../windowAuctionDescription.js';
import WindowAuctionTenderAttempt from '../../windowAuctionTenderAttempt.js';
import MartialLawDisclaimer from '../../martialLawDisclaimer.js'
import WindowAuctionAccessDetails from '../../windowAuctionAccessDetails.js';
import WindowAuctionDocumentRequirements from '../../windowAuctionDocumentRequirements.js';
import WindowAuctionAdditionalInformation from '../../windowAuctionAdditionalInformation.js';
import WindowAuctionType from '../../auctionsCommon/windowAuctionType/windowAuctionType.js';
import WindowAuctionCost from '../../windowAuctionCost.js';

import ValueAddedTaxCharged from '../../valueAddedTaxCharged.js';
import IsPerishable  from '../../isPerishable.js';

import WindowAuctionGaranty from '../../windowAuctionGaranty.js';
import WindowAuctionMinimalStep from '../../windowAuctionMinimalStep.js';
import WindowAuctionDiscount from '../../windowAuctionDiscount.js';

import WindowAuctionDutchSteps from '../../windowAuctionDutchSteps.js';
import MinNumberOfQualifiedBids from '../../minNumberOfQualifiedBids'

import WindowAuctionDgf from '../../dgf.js';
import LandRental from '../../landRental'
import WindowAuctionZU from '../../zu.js';
import WindowAuctionZUBanlAccounts from '../../zuBankAccounts'
import WindowAuctionLandRentalBanlAccounts from '../../WindowAuctionLandRentalBanlAccounts'
import WindowAuctionBaseSellBankAccounts from '../../WindowAuctionBaseSellBankAccounts'

import ReturnButton from '../../../returnButton'
import ViewAddBankAccont from '../../viewAddBankAccont.js';

import CreateAuctionLoader from '../../../createAuctionLoader.js';

import LegitimatePropertyLeaseLeaseDuration from '../legitimatePropertyLeaseLeaseDuration'
import RailWayCargoDutchMinNumberOfQualifiedBids from '../railWayCargoDutchMinNumberOfQualifiedBids'

import RegistrationFee from '../../windowAuctionRegistrationFee'
import LandRentalLeaseType from '../../landRental_leaseType'

import {disabledElement, onOffCurrentTenat} from '../../../disabled'

import {checkingFilledFields} from '../checkingFilledFields'
import procedure from '../../../../../redux/procedure';
import { bankAccountGet } from '../../../../../redux/actions/bankAccount/bankAccount.js';
import Sidebar from '../../../auctionEditNew/components/sidebar/sidebar';
import InputDate from '../../../../elements/inputs/inputDate';

import {getDefaultHeaders} from "../../../../_api/bidApi";
const WindowAuction = ( props ) => {

    useEffect(() => {
        let dataBank = {}
        dataBank.domen = process.env.REACT_APP_END_POINT_BD
        dataBank.version = 'v1'
        dataBank.local = props.langFlag
        dataBank.params = `?offset=0`
        props.bankAccountGet(dataBank, getDefaultHeaders(props))
    }, [])

    let tmp;
    let tmpBank = null
    let tmpBankSelect = null
    let tmpRegistrationFee = null
    let tmpLandRentalLeaseType = null
    if(props.auctionsMy !== null){
        switch (true) {
            case procedure.isLSE(props.auctionsMy.sellingMethod):
                tmpRegistrationFee = <RegistrationFee/>
                tmpLandRentalLeaseType = <LandRentalLeaseType/>
                break;
            case procedure.isLRE(props.auctionsMy.sellingMethod):
                tmpRegistrationFee = <RegistrationFee/>
                tmpLandRentalLeaseType = <LandRentalLeaseType/>
                break;
            case procedure.isLSP(props.auctionsMy.sellingMethod):
                tmpRegistrationFee = <RegistrationFee/>
                tmpLandRentalLeaseType = <LandRentalLeaseType/>
                break
            case procedure.isBSD(props.auctionsMy.sellingMethod) :
            case procedure.isBSE(props.auctionsMy.sellingMethod) :
            case procedure.isALE(props.auctionsMy.sellingMethod) :
            case procedure.isCSE(props.auctionsMy.sellingMethod) :
            case procedure.isCSD(props.auctionsMy.sellingMethod) :
            case procedure.isBRE(props.auctionsMy.sellingMethod) :
            case procedure.isBRD(props.auctionsMy.sellingMethod) :
            case procedure.isNLE(props.auctionsMy.sellingMethod) :
            case procedure.isNLD(props.auctionsMy.sellingMethod) :
            case procedure.isLAE(props.auctionsMy.sellingMethod) :
            case procedure.isLAW(props.auctionsMy.sellingMethod) :
            case procedure.isLAP(props.auctionsMy.sellingMethod) :
            case procedure.isRCE(props.auctionsMy.sellingMethod):
            case procedure.isRCD(props.auctionsMy.sellingMethod):
            case props.auctionsMy.sellingMethod.includes('railwayCargo-dutch'):
                tmpRegistrationFee = <RegistrationFee/>
                break;
        }
    }
    if(props.auctionsMy !== null){
        if(
            procedure.isLLE(props.auctionsMy.sellingMethod) ||
            procedure.isLLD(props.auctionsMy.sellingMethod) ||
            procedure.isLLP(props.auctionsMy.sellingMethod)
        ){
            if(props.auctionsSwitchWindow !== 2){
                if(props.auctionsMy.hasOwnProperty('leaseRules') === true){
                    if(props.auctionsMy.leaseRules !== null){
                        if(props.auctionsMy.leaseRules.hasOwnProperty('schedule') === true){
                            if(props.auctionsMy.leaseRules.schedule !== null){
                                if(props.schedule.flag === false){
                                    props.setDataAddress(true, 'SET_SCHEDULE_FLAG')
                                    if(props.auctionsMy.leaseRules.schedule.hasOwnProperty('hoursBy') === true){
                                        if(props.auctionsMy.leaseRules.schedule.hoursBy !== null){
                                            if(props.auctionsMy.leaseRules.schedule.hoursBy.value !== null && props.auctionsMy.leaseRules.schedule.hoursBy.value !== ''){
                                                if(props.schedule.hoursBy.value !== props.auctionsMy.leaseRules.schedule.hoursBy.value){
                                                    props.setDataAddress(props.auctionsMy.leaseRules.schedule.hoursBy.value, 'SET_SCHEDULE_HOURS_BY_VALUE')
                                                }
                                            }
                                            if(props.auctionsMy.leaseRules.schedule.hoursBy.by !== null && props.auctionsMy.leaseRules.schedule.hoursBy.by !== 'null'){
                                                if(props.schedule.hoursBy.by !== props.auctionsMy.leaseRules.schedule.hoursBy.by){
                                                    props.setDataAddress(props.auctionsMy.leaseRules.schedule.hoursBy.by, 'SET_SCHEDULE_HOURS_BY_BY')
                                                }
                                            }
                                        }
                                    }
                                    if(props.auctionsMy.leaseRules.schedule.hasOwnProperty('daysBy') === true){
                                        if(props.auctionsMy.leaseRules.schedule.daysBy !== null){
                                            if(props.auctionsMy.leaseRules.schedule.daysBy.value !== null && props.auctionsMy.leaseRules.schedule.daysBy.value !== ''){
                                                if(props.schedule.daysBy.value !== props.auctionsMy.leaseRules.schedule.daysBy.value){
                                                    props.setDataAddress(props.auctionsMy.leaseRules.schedule.daysBy.value, 'SET_SCHEDULE_DAYS_BY_VALUE')
                                                }
                                            }
                                            if(props.auctionsMy.leaseRules.schedule.daysBy.by !== null && props.auctionsMy.leaseRules.schedule.daysBy.by !== 'null'){
                                                if(props.schedule.daysBy.by !== props.auctionsMy.leaseRules.schedule.daysBy.by){
                                                    props.setDataAddress(props.auctionsMy.leaseRules.schedule.daysBy.by, 'SET_SCHEDULE_DAYS_BY_BY')
                                                }
                                            }
                                        }
                                    }
                                }
                                if(props.schedule.other === null){
                                    if(props.auctionsMy.leaseRules.schedule.other !== null && props.auctionsMy.leaseRules.schedule.other !== ''){
                                        props.setDataAddress(props.auctionsMy.leaseRules.schedule.other, 'SET_SCHEDULE_OTHER')
                                    }
                                }
                            }
                        }
                    }
                }
            }
            tmpBank = <WindowAuctionZUBanlAccounts />
            tmpBankSelect = null
        }else if(
            procedure.isLRE(props.auctionsMy.sellingMethod) ||
            procedure.isLSE(props.auctionsMy.sellingMethod) ||
            procedure.isLSP(props.auctionsMy.sellingMethod)
        ){
            tmpBank = <WindowAuctionLandRentalBanlAccounts />
            tmpBankSelect = null
        }else if(
            procedure.isBSD(props.auctionsMy.sellingMethod) || procedure.isBSE(props.auctionsMy.sellingMethod) ||
            procedure.isALE(props.auctionsMy.sellingMethod) ||
            procedure.isCSE(props.auctionsMy.sellingMethod) || procedure.isCSD(props.auctionsMy.sellingMethod) ||
            procedure.isBRE(props.auctionsMy.sellingMethod) || procedure.isBRD(props.auctionsMy.sellingMethod) ||
            procedure.isNLE(props.auctionsMy.sellingMethod) || procedure.isNLD(props.auctionsMy.sellingMethod) ||
            procedure.isLAE(props.auctionsMy.sellingMethod) || procedure.isLAW(props.auctionsMy.sellingMethod) || procedure.isLAP(props.auctionsMy.sellingMethod)
        ){
            tmpBank = <WindowAuctionBaseSellBankAccounts />
        }else if(
            !procedure.isSUE(props.auctionsMy.sellingMethod) &&
            !procedure.isSUD(props.auctionsMy.sellingMethod) &&
            !props.auctionsMy.sellingMethod.startsWith('renewables-multiAwards')
        ){
            tmpBank = <ViewAddBankAccont />
            tmpBankSelect = <TextField
                className={styles.inputMaxBank}
                disabled={disabledElement(props.auctionsMy, '01')}
                id="outlined-select-currency-native"
                select
                label="Банківський рахунок"
                value={props.bankAccountId}
                onChange={(event)=>{
                    let tmpBankAdd = props.bankAccountWork.addNewBank
                    tmpBankAdd.push(event.target.value)
                    props.setBankAccountAdd(tmpBankAdd)
                    props.setPopBankAccountId(event.target.value)
                    addArrayBankAccounts(props, event.target.value)
                }}
                SelectProps={{
                    native: true,
                }}
                helperText="Обрати банківський рахунок"
                variant="outlined"
            >
                <option key={0} selected disabled value='null'>Обрати</option>
                {selectBankAuction(props)}
            </TextField>
        }
    }

    if(props.auctionsMy !== null && props.auctionsSwitchWindow === 1){
        if(
            procedure.isBSE(props.auctionsMy.sellingMethod) || procedure.isBSD(props.auctionsMy.sellingMethod) ||
            procedure.isALE(props.auctionsMy.sellingMethod) ||
            procedure.isCSE(props.auctionsMy.sellingMethod) || procedure.isCSD(props.auctionsMy.sellingMethod) ||
            procedure.isBRE(props.auctionsMy.sellingMethod) || procedure.isBRD(props.auctionsMy.sellingMethod) ||

            procedure.isRLE(props.auctionsMy.sellingMethod) || procedure.isRLD(props.auctionsMy.sellingMethod) ||
            procedure.isCLE(props.auctionsMy.sellingMethod) || procedure.isCLD(props.auctionsMy.sellingMethod) ||
            procedure.isBRW(props.auctionsMy.sellingMethod) ||
            procedure.isSPE(props.auctionsMy.sellingMethod) || procedure.isSPD(props.auctionsMy.sellingMethod) ||
            procedure.isNLE(props.auctionsMy.sellingMethod) || procedure.isNLD(props.auctionsMy.sellingMethod) ||
            procedure.isLAE(props.auctionsMy.sellingMethod) || procedure.isLAW(props.auctionsMy.sellingMethod) || procedure.isLAP(props.auctionsMy.sellingMethod) ||
            procedure.isLPE(props.auctionsMy.sellingMethod)
            || procedure.isAPE(props.auctionsMy.sellingMethod) || procedure.isAPD(props.auctionsMy.sellingMethod)
            || procedure.isLLE(props.auctionsMy.sellingMethod) || procedure.isLLD(props.auctionsMy.sellingMethod)
            || procedure.isLRE(props.auctionsMy.sellingMethod) || procedure.isLSE(props.auctionsMy.sellingMethod) || procedure.isLSP(props.auctionsMy.sellingMethod)
        ){
            tmp = <div>
                <div className={styles.mainWrap}>
                    <Sidebar />
                    <div className={styles.wrapBlock} >
                        <div className={styles.group}>
                            <WindowAuctionType typeElem={1} />
                        </div>
                        <div className={styles.bottonBlock}>
                            {createNew(props)}
                        </div>
                        <div className={styles.bottonBlock}>
                            <ReturnButton />
                        </div>
                        <div className={styles.helper}>* Поля обов'язкові для заповнення</div>
                    </div>
                </div>
            </div>
        }
        else{
            let minStep = null;
            if(props.auctionsMy.hasOwnProperty('minimalStep') === true){
                if(props.auctionsMy.minimalStep !== null){
                    if(props.auctionsMy.minimalStep.hasOwnProperty("currency") === true){
                        if(props.auctionsMy.minimalStep.currency !== null){
                            minStep = props.auctionsMy.minimalStep.currency
                        }
                    }
                }
            }

            if(props.auctionsMy.hasOwnProperty('bankAccounts') === true){
                if(props.auctionsMy.bankAccounts.length !== null){
                    if(props.auctionsMy.bankAccounts.length > 0){
                        props.setPopBankAccountId(props.auctionsMy.bankAccounts[0].id)
                    }
                }
            }

            tmp = <div>
                <div className={styles.mainWrap}>
                    <Sidebar />
                    <div className={styles.wrapBlock} >
                        {viewIdElements(props)}
                        <div className={styles.group}>
                            <WindowAuctionType typeElem={1} />
                            <WindowAuctionSelfNumber typeElem={1} />
                            <WindowAuctionTitle typeElem={1} />
                            <WindowAuctionDescription typeElem={1} />
                            <div className={styles.groupElem}>
                                <WindowAuctionTenderAttempt typeElem={1} />
                            </div>
                            <div className={styles.groupElem}>
                                <MartialLawDisclaimer />
                            </div>
                            <div className={styles.groupElem}>
                                <WindowAuctionAccessDetails typeElem={1} />
                            </div>
                            <div className={styles.groupElem}>
                                <WindowAuctionDocumentRequirements typeElem={1} />
                            </div>
                            <div className={styles.groupElem}>
                                <WindowAuctionAdditionalInformation typeElem={1} />
                            </div>
                            <div>
                                {viewMinNumberOfQualifiedBids(props, 1)}
                            </div>
                            {viewRailWayCargoDutch(1)}
                            <IsPerishable />
                        </div>

                        <WindowAuctionCost typeElem={1} />
                        <ValueAddedTaxCharged />
                        <WindowAuctionGaranty typeElem={1} />
                        <WindowAuctionMinimalStep typeElem={1} />
                        {tmpRegistrationFee}
                        {tmpLandRentalLeaseType}
                        <WindowAuctionDiscount typeElem={1} />
                        <div className={styles.group}>
                            {closeClock(props)}
                    {viewSubsoil(props)}
                            <LegitimatePropertyLeaseLeaseDuration />
                    {viewWagonSelected(props)}
                    {bankAccountView(props, tmpBank, tmpBankSelect)}
                </div>
                    </div>
                </div>
                <div className={styles.bottonBlock}>
                    {createOrEdit(props, minStep)}
                </div>
                <div className={styles.bottonBlock}>
                    <ReturnButton />
                </div>
                <div className={styles.helper}>* Поля обов'язкові для заповнення</div>
            </div>
        }
    }else if(props.auctionsMy !== null && props.auctionsSwitchWindow === 3){
        if(
            procedure.isBSE(props.auctionsMy.sellingMethod) || procedure.isBSD(props.auctionsMy.sellingMethod) ||
            procedure.isALE(props.auctionsMy.sellingMethod) ||
            procedure.isCSE(props.auctionsMy.sellingMethod) || procedure.isCSD(props.auctionsMy.sellingMethod) ||
            procedure.isBRE(props.auctionsMy.sellingMethod) || procedure.isBRD(props.auctionsMy.sellingMethod) ||

            procedure.isRLE(props.auctionsMy.sellingMethod) || procedure.isRLD(props.auctionsMy.sellingMethod) ||
            procedure.isCLE(props.auctionsMy.sellingMethod) || procedure.isCLD(props.auctionsMy.sellingMethod) ||
            procedure.isBRW(props.auctionsMy.sellingMethod) ||
            procedure.isSPE(props.auctionsMy.sellingMethod) || procedure.isSPD(props.auctionsMy.sellingMethod) ||
            procedure.isNLE(props.auctionsMy.sellingMethod) || procedure.isNLD(props.auctionsMy.sellingMethod) ||
            procedure.isLAE(props.auctionsMy.sellingMethod) || procedure.isLAW(props.auctionsMy.sellingMethod) || procedure.isLAP(props.auctionsMy.sellingMethod) ||
            procedure.isLPE(props.auctionsMy.sellingMethod)
            || procedure.isAPE(props.auctionsMy.sellingMethod) || procedure.isAPD(props.auctionsMy.sellingMethod)
            || procedure.isLLE(props.auctionsMy.sellingMethod) || procedure.isLLD(props.auctionsMy.sellingMethod)
        ){
            tmp = <div>
                <div className={styles.mainWrap}>
                    <Sidebar />
                    <div className={styles.wrapBlock} >
                        <div className={styles.group}>
                            <WindowAuctionType typeElem={1} />
                        </div>
                        <div className={styles.bottonBlock}>
                            {createNew(props)}
                        </div>
                        <div className={styles.bottonBlock}>
                            <ReturnButton />
                        </div>
                        <div className={styles.helper}>* Поля обов'язкові для заповнення</div>
                    </div>
                </div>
            </div>
        } else {
            let minStep = null;
            if(props.auctionsMy.minimalStep !== null){
                if(props.auctionsMy.minimalStep.currency !== null){
                    minStep = props.auctionsMy.minimalStep.currency
                }
            }

            if(props.auctionsMy.bankAccounts.length > 0){
                props.setPopBankAccountId(props.auctionsMy.bankAccounts[0].id)
            }
            tmp = <div>
                <div className={styles.mainWrap}>
                    <Sidebar />
                    <div className={styles.wrapBlock} >
                        {viewIdElements(props)}
                        <div className={styles.group}>
                            <WindowAuctionTitle typeElem={2}/>
                            <WindowAuctionSelfNumber typeElem={2} />
                            <WindowAuctionDescription typeElem={2} />
                            <div className={styles.groupElem}>
                                <WindowAuctionTenderAttempt typeElem={2} />
                            </div>
                            <div className={styles.groupElem}>
                                <MartialLawDisclaimer />
                            </div>
                            <div className={styles.groupElem}>
                                <WindowAuctionAccessDetails typeElem={2} />
                            </div>
                            <div className={styles.groupElem}>
                                <WindowAuctionDocumentRequirements typeElem={2} />
                            </div>
                            <div className={styles.groupElem}>
                                <WindowAuctionAdditionalInformation typeElem={2} />
                            </div>
                            <div className={styles.groupElem}>
                                <WindowAuctionType typeElem={2} />
                            </div>
                            <div>
                                {viewMinNumberOfQualifiedBids(props, 2)}
                            </div>
                            {viewRailWayCargoDutch(2)}
                            <IsPerishable />
                        </div>
                        <WindowAuctionCost typeElem={2} />
                        <ValueAddedTaxCharged />
                        <WindowAuctionGaranty typeElem={2} />
                        <WindowAuctionMinimalStep typeElem={2} />
                        {tmpRegistrationFee}
                        {tmpLandRentalLeaseType}
                        <WindowAuctionDiscount typeElem={2} />
                        <div className={styles.group}>
                            {closeClock(props)}
                        {viewSubsoil(props)}
                            <LegitimatePropertyLeaseLeaseDuration />
                        {viewWagonSelected(props)}
                        {bankAccountView(props, tmpBank, tmpBankSelect)}
                    </div>
                    </div>
                </div>
                <div className={styles.bottonBlock}>
                    {createOrEdit(props, minStep)}
                </div>
                <div className={styles.bottonBlock}>
                    <Link
                        to="/create_auctions"
                        className={styles.buttons}
                        variant="contained"
                        color="primary"
                        onClick={
                            () => {
                                props.changeAuctionsSwitchWindow(0)
                                props.changeCreateAuctionLotIdentifier('')
                                props.changeCreateAuctionTitle('')
                                props.changeCreateAuctionDescription('')
                                props.changeCreateAuctionTenderAttempts('')
                                props.changeCreateAuctionAccessDetails('')
                                props.changeCreateAuctionXDocumentRequirements('')
                                props.changeCreateAuctionXAdditionalInformation('')
                                props.changeCreateAuctionType('null')
                                props.changeCreateAuctionValueCurrency('null')
                                props.changeCreateAuctionValueAmount('')
                                props.changeCreateAuctionGuaranteeCurrency('null')
                                props.changeCreateAuctionGuaranteeAmount('')
                                props.changeCreateAuctionMinimalStepCurrency('null')
                                props.changeCreateAuctionMinimalStepAmount('')
                                props.changeCreateAuctionDateStart('')
                                props.setPopBankAccountId('null')
                                props.setPopBankAccountIdArr(null)
                                props.getMyAuction(null)
                            }
                        }
                    >
                        Повернутися до списку аукціонів
                    </Link>
                </div>
                <div>* Поля обов'язкові для заповнення</div>
            </div>
        }
    }else{
        if(
            procedure.isBSE(props.auctionsMy.sellingMethod) || procedure.isBSD(props.auctionsMy.sellingMethod) ||
            procedure.isALE(props.auctionsMy.sellingMethod) ||
            procedure.isCSE(props.auctionsMy.sellingMethod) || procedure.isCSD(props.auctionsMy.sellingMethod) ||
            procedure.isBRE(props.auctionsMy.sellingMethod) || procedure.isBRD(props.auctionsMy.sellingMethod) ||

            procedure.isRLE(props.auctionsMy.sellingMethod) || procedure.isRLD(props.auctionsMy.sellingMethod) ||
            procedure.isCLE(props.auctionsMy.sellingMethod) || procedure.isCLD(props.auctionsMy.sellingMethod) ||
            procedure.isBRW(props.auctionsMy.sellingMethod) ||
            procedure.isSPE(props.auctionsMy.sellingMethod) || procedure.isSPD(props.auctionsMy.sellingMethod) ||
            procedure.isNLE(props.auctionsMy.sellingMethod) || procedure.isNLD(props.auctionsMy.sellingMethod) ||
            procedure.isLAE(props.auctionsMy.sellingMethod) || procedure.isLAW(props.auctionsMy.sellingMethod) || procedure.isLAP(props.auctionsMy.sellingMethod) ||
            procedure.isLPE(props.auctionsMy.sellingMethod)
            || procedure.isAPE(props.auctionsMy.sellingMethod) || procedure.isAPD(props.auctionsMy.sellingMethod)
            || procedure.isLLE(props.auctionsMy.sellingMethod) || procedure.isLLD(props.auctionsMy.sellingMethod)
            || procedure.isLRE(props.auctionsMy.sellingMethod) || procedure.isLSE(props.auctionsMy.sellingMethod) || procedure.isLSP(props.auctionsMy.sellingMethod)
            || props.auctionsMy.sellingMethod.startsWith("renewables-multiAwards")
        ){
            tmp = <div>
                <div className={styles.mainWrap}>
                    <Sidebar />
                    <div className={styles.wrapBlock} >
                        <div className={styles.group}>
                            <WindowAuctionType typeElem={1} />
                        </div>
                        <div className={styles.bottonBlock}>
                            {createNew(props)}
                        </div>
                        <div className={styles.bottonBlock}>
                            <ReturnButton />
                        </div>
                        <div className={styles.helper}>* Поля обов'язкові для заповнення</div>
                    </div>
                </div>
            </div>
        }else{
            let minStep = null;
            if(props.auctionsMy !== null){
                if(props.auctionsMy.minimalStep !== null){
                    if(props.auctionsMy.minimalStep.currency !== null){
                        minStep = props.auctionsMy.minimalStep.currency
                    }
                }
                tmp = <div>
                    <div className={styles.mainWrap}>
                    <Sidebar />
                    <div className={styles.wrapBlock} >
                        <WindowAuctionType typeElem={1} />
                        <WindowAuctionSelfNumber typeElem={1} />
                        <WindowAuctionTitle typeElem={1} />
                        <WindowAuctionDescription typeElem={1} />
                        <WindowAuctionTenderAttempt typeElem={1} />
                        <MartialLawDisclaimer />
                        <WindowAuctionAccessDetails typeElem={1} />
                        <WindowAuctionDocumentRequirements typeElem={1} />
                        <WindowAuctionAdditionalInformation typeElem={1} />
                        {viewMinNumberOfQualifiedBids(props, 1)}
                        {viewRailWayCargoDutch(1)}
                        <IsPerishable />
                        <div className={styles.costBlock}>
                            <WindowAuctionCost typeElem={1} />
                            <ValueAddedTaxCharged />
                            <WindowAuctionGaranty typeElem={1} />
                            <WindowAuctionMinimalStep typeElem={1} />
                            {tmpRegistrationFee}
                            {tmpLandRentalLeaseType}
                            <WindowAuctionDiscount typeElem={1} />
                        </div>
                        <div className={styles.startDate}>
                                {closeClock(props)}
                        </div>
                        {viewSubsoil(props)}
                        <LegitimatePropertyLeaseLeaseDuration />
                        {viewWagonSelected(props)}
                        {bankAccountView(props, tmpBank, tmpBankSelect)}
                        </div>
                    </div>
                    <div className={styles.bottonBlock}>
                        {createOrEdit(props, minStep)}
                    </div>
                    <div className={styles.bottonBlock}>
                        <Link
                            to="/create_auctions"
                            className={styles.buttons}
                            variant="contained"
                            color="primary"
                            onClick={
                                () => {
                                    props.changeAuctionsSwitchWindow(0)
                                    props.changeCreateAuctionLotIdentifier('')
                                    props.changeCreateAuctionTitle('')
                                    props.changeCreateAuctionDescription('')
                                    props.changeCreateAuctionTenderAttempts('')
                                    props.changeCreateAuctionAccessDetails('')
                                    props.changeCreateAuctionXDocumentRequirements('')
                                    props.changeCreateAuctionXAdditionalInformation('')
                                    props.changeCreateAuctionType('null')
                                    props.changeCreateAuctionValueCurrency('null')
                                    props.changeCreateAuctionValueAmount('')
                                    props.changeCreateAuctionGuaranteeCurrency('null')
                                    props.changeCreateAuctionGuaranteeAmount('')
                                    props.changeCreateAuctionMinimalStepCurrency('null')
                                    props.changeCreateAuctionMinimalStepAmount('')
                                    props.changeCreateAuctionDateStart('')
                                    props.setPopBankAccountId('null')
                                    props.setPopBankAccountIdArr(null)
                                    props.getMyAuction(null)
                                }
                            }
                        >
                            Повернутися до списку аукціонів
                        </Link>
                    </div>
                    <div>* Поля обов'язкові для заповнення</div>
                </div>
            }else{
                tmp = <CreateAuctionLoader />
            }
        }
    }
    return tmp
}

function closeClock(props){
    if(props.auctionsMy.isPerishable === true || props.auctionsMy.isPerishable === 'true'){
        return (
            <>
            <div className={styles.costBlockTitle}>Дата аукціону</div>
            {dateStartAuction(props, 'disabled')}
            </>
        )
    }
    return (
        <>
        <div className={styles.costBlockTitle}>Дата аукціону</div>
        {dateStartAuction(props, null)}
        </>
    )
}

function bankAccountView(props, tmpBank, tmpBankSelect){
    if(
        procedure.isBSD(props.auctionsMy.sellingMethod) || procedure.isBSE(props.auctionsMy.sellingMethod) ||
        procedure.isALE(props.auctionsMy.sellingMethod) ||
        procedure.isCSE(props.auctionsMy.sellingMethod) || procedure.isCSD(props.auctionsMy.sellingMethod) ||
        procedure.isBRE(props.auctionsMy.sellingMethod) || procedure.isBRD(props.auctionsMy.sellingMethod) ||
        procedure.isNLE(props.auctionsMy.sellingMethod) || procedure.isNLD(props.auctionsMy.sellingMethod) ||
        procedure.isLAE(props.auctionsMy.sellingMethod) || procedure.isLAW(props.auctionsMy.sellingMethod) || procedure.isLAP(props.auctionsMy.sellingMethod)
    ){
        return <WindowAuctionBaseSellBankAccounts />
    }else if(
        props.auctionsMy.sellingMethod !== "subsoil-english" &&
        props.auctionsMy.sellingMethod !== "subsoil-english-fast" &&
        props.auctionsMy.sellingMethod !== "subsoil-english-fast-manual" &&
        props.auctionsMy.sellingMethod !== "subsoil-english-initial-auction" &&
        props.auctionsMy.sellingMethod !== "subsoil-english-initial-qualification" &&
        props.auctionsMy.sellingMethod !== "subsoil-dutch" &&
        props.auctionsMy.sellingMethod !== "subsoil-dutch-fast" &&
        props.auctionsMy.sellingMethod !== "subsoil-dutch-fast-manual" &&
        props.auctionsMy.sellingMethod !== "subsoil-dutch-initial-auction" &&
        props.auctionsMy.sellingMethod !== "subsoil-dutch-initial-qualification" &&
        props.auctionsMy.sellingMethod !== "subsoil-dutch-initial-auction-manual" &&
        props.auctionsMy.sellingMethod !== "subsoil-english-fast-auction-manual-qualification"
    ){
        return (
            <>
                <div className={styles.groupElem + ' ' + styles.bankAccountElements}>
                    <div className={styles.bankAccountTitle}>Банківські реквізити</div>
                    {tmpBank}
                </div>
                <div className={styles.groupElem}>
                    <div>
                        {tmpBankSelect}
                        <div className={styles.bottonBlock}>
                            <Button
                                disabled={elementDisabledCreate(props)}
                                className={styles.buttonExitDocument}
                                variant="contained"
                                color="primary"
                                onClick={
                                    () => {
                                        props.openBankWindows(true)
                                    }
                                }
                            >
                                Створити та редагувати банківський рахунок
                            </Button>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    return null
}

function zuDutchStep(props){
    if(
        props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch" ||
        props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-fast" ||
        props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-fast-manual" ||
        props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-fast-auction-manual-qualification" ||
        props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-initial-auction" ||
        props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-initial-auction-manual" ||
        props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-initial-qualification-prod" ||
        props.auctionsMy.sellingMethod === 'basicSell-dutch' ||
        props.auctionsMy.sellingMethod === 'basicSell-dutch-fast' ||
        props.auctionsMy.sellingMethod === 'basicSell-dutch-fast-manual' ||
        props.auctionsMy.sellingMethod === 'basicSell-dutch-fast-auction-manual-qualification' ||
        props.auctionsMy.sellingMethod === 'basicSell-dutch-initial-auction' ||
        props.auctionsMy.sellingMethod === 'basicSell-dutch-initial-auction-manual' ||
        props.auctionsMy.sellingMethod === 'basicSell-dutch-initial-qualification' ||
        props.auctionsMy.sellingMethod === 'basicSell-dutch-initial-qualification-prod' ||
        props.auctionsMy.sellingMethod === 'commercialSell-dutch' ||
        props.auctionsMy.sellingMethod === 'commercialSell-dutch-fast' ||
        props.auctionsMy.sellingMethod === 'commercialSell-dutch-fast-manual' ||
        props.auctionsMy.sellingMethod === 'commercialSell-dutch-fast-auction-manual-qualification' ||
        props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-auction' ||
        props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-auction-manual' ||
        props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-qualification' ||
        props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-qualification-prod' ||
        props.auctionsMy.sellingMethod === 'bankRuptcy-dutch' ||
        props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-fast' ||
        props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-fast-manual' ||
        props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-fast-auction-manual-qualification' ||
        props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-auction' ||
        props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-auction-manual' ||
        props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-qualification' ||
        props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-qualification-prod' ||
        props.auctionsMy.sellingMethod === "nonperformingLoans-dutch" ||
        props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-fast" ||
        props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-fast-manual" ||
        props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-fast-auction-manual-qualification" ||
        props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-fast-auction-prod" ||
        props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-initial-auction" ||
        props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-initial-auction-manual" ||
        props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-initial-qualification" ||
        props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-initial-qualification-prod"
    ){
        return <WindowAuctionDutchSteps />
    }
}

function viewMinNumberOfQualifiedBids(props, type){
    switch(props.auctionsMy.sellingMethod){
        case props.auctionsMy.sellingMethod.startsWith("dgf-english"):
        case props.auctionsMy.sellingMethod.startsWith("dgf-dutch"):
            return <WindowAuctionDgf typeElem={type} />
        case props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-english"):
        case props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-dutch"):
        case props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish"):
            return <>
                {zuDutchStep(props)}
                <WindowAuctionZU typeElem={type} />
                </>
        case props.auctionsMy.sellingMethod.startsWith("landRental-english"):
        case props.auctionsMy.sellingMethod.startsWith("landSell-english"):
            return null
        case props.auctionsMy.sellingMethod.startsWith("landSell-priorityEnglish"):
            return <LandRental typeElem={type} />

        case props.auctionsMy.sellingMethod.startsWith("basicSell-english"):
        case props.auctionsMy.sellingMethod.startsWith("alienation-english"):
        case props.auctionsMy.sellingMethod.startsWith("commercialSell-english"):
        case props.auctionsMy.sellingMethod.startsWith("bankRuptcy-english"):
        case props.auctionsMy.sellingMethod.startsWith("nonperformingLoans-english"):
            return <MinNumberOfQualifiedBids typeElem={type} />
        case props.auctionsMy.sellingMethod.startsWith("basicSell-dutch"):
        case props.auctionsMy.sellingMethod.startsWith("commercialSell-dutch"):
        case props.auctionsMy.sellingMethod.startsWith("bankRuptcy-dutch"):
        case props.auctionsMy.sellingMethod.startsWith("nonperformingLoans-dutch"):
            return  zuDutchStep(props)
        case props.auctionsMy.sellingMethod.startsWith("arrestedAssets-english"):
            return <>
                <MinNumberOfQualifiedBids typeElem={type} />
                {zuDutchStep(props)}
            </>

        default:
            return null
    }
}

function viewRailWayCargoDutch(){
    return <RailWayCargoDutchMinNumberOfQualifiedBids />
}

function viewSubsoil(props){
    let tmp = null;
    switch(props.auctionsMy.sellingMethod){
        case "subsoil-english":
        case "subsoil-english-fast":
        case "subsoil-english-fast-manual":
        case "subsoil-english-initial-auction":
        case "subsoil-english-initial-qualification":
        case "subsoil-dutch":
        case "subsoil-dutch-fast":
        case "subsoil-dutch-fast-manual":
        case "subsoil-dutch-initial-auction":
        case "subsoil-dutch-initial-qualification":
        case "subsoil-dutch-initial-auction-manual":
        case "subsoil-english-fast-auction-manual-qualification":
            tmp = <>
                <div className={styles.groupElem + ' ' + styles.groupElemCategory + " " + styles.groupElemSue}>
                    <div className={styles.sue}>
                        <TextField
                            disabled={disabledElement(props.auctionsMy, '01')}
                            label="Вартість геологічної інформації"
                            value={viewGeologivDataValue(props)}
                            onChange={(event) => {
                                props.changeCreateItemGeologivDataValue(event.target.value)
                            }}
                            name="numberformat"
                            id="formatted-numberformat-input"
                            //helperText="Вартість геологічної інформації"
                            variant="outlined"
                        />
                    </div>
                </div>
                <div className={styles.groupElem + ' ' + styles.groupElemCategory + " " + styles.groupElemSue}>
                    <div className={styles.sue}>
                        <TextField
                            disabled={disabledElement(props.auctionsMy, '01')}
                            label="Вартість пакета аукціонної документації, що сплачується переможцем"
                            value={viewDocumentationValue(props)}
                            onChange={(event) => {
                                props.changeCreateItemDocumentationValue(event.target.value)
                            }}
                            name="numberformat"
                            id="formatted-numberformat-input"
                            variant="outlined"
                        />
                    </div>
                </div>
                <div className={styles.groupElem + ' ' + styles.groupElemCategory}>
                    Строк, на який надається дозвіл
                </div>
                <div className={styles.groupElem + ' ' + styles.groupElemCategory}>
                    <div>
                        <TextField
                            disabled={disabledElement(props.auctionsMy, '00')}
                            label="Років"
                            type="number"
                            value={handleViewDate(props, 1)}
                            onChange={(event) => {
                                handleDate(props, event.target.value, 1)
                            }}
                            name="numberformat"
                            id="formatted-numberformat-input"
                            helperText="Років"
                            variant="outlined"
                        />
                    </div>
                    <div>
                        <TextField
                            disabled={disabledElement(props.auctionsMy, '00')}
                            label="Місяців"
                            type="number"
                            value={handleViewDate(props, 2)}
                            onChange={(event) => {
                                if(Number(event.target.value) < 13){
                                    handleDate(props, event.target.value, 2)
                                }
                            }}
                            name="numberformat"
                            id="formatted-numberformat-input"
                            helperText="Місяців"
                            variant="outlined"
                        />
                    </div>
                </div>
            </>
            break;
        default:
            break;
    }
    return tmp
}

function handleViewDate(props, type){
    let tmp = null;
    if(props.auctionsMy.leaseDuration !== null){
        let tmpArr = props.auctionsMy.leaseDuration.split('P')
        let tmpArr1 = tmpArr[1].split('Y')
        let tmpArr2 = tmpArr1[1].split('M')
        let tmpArr3 = tmpArr2[1].split('D')
        if(type === 1){
            if(tmpArr1[0] !== '0'){
                tmp = tmpArr1[0]
            }else{
                tmp = ''
            }
        }else if(type === 2){
            if(tmpArr2[0] !== '0'){
                tmp = tmpArr2[0]
            }else{
                tmp = ''
            }
        }else if(type === 3){
            if(tmpArr3[0] !== '0'){
                tmp = tmpArr3[0]
            }else{
                tmp = ''
            }
        }
    }else{
        if(type === 1){
            tmp = ``
        }else if(type === 2){
            tmp = ``
        }else if(type === 3){
            tmp = ``
        }
    }
    return tmp
}

function handleDate(props, date, type){
    let tmp = null;
    if(props.auctionsMy.leaseDuration !== null){
        let tmpArr = props.auctionsMy.leaseDuration.split('P')
        let tmpArr1 = tmpArr[1].split('Y')
        let tmpArr2 = tmpArr1[1].split('M')
        let tmpArr3 = tmpArr2[1].split('D')
        if(type === 1){
            if(date === ''){
                tmp = `P0Y${tmpArr2[0]}M${tmpArr3[0]}D`
            }else{
                tmp = `P${date}Y${tmpArr2[0]}M${tmpArr3[0]}D`
            }
        }else if(type === 2){
            tmp = `P${tmpArr1[0]}Y${date}M${tmpArr3[0]}D`
            if(date === ''){
                tmp = `P${tmpArr1[0]}Y0M${tmpArr3[0]}D`
            }else{
                tmp = `P${tmpArr1[0]}Y${date}M${tmpArr3[0]}D`
            }
        }
        else if(type === 3){
            tmp = `P${tmpArr1[0]}Y${tmpArr2[0]}M${date}D`
            if(date === ''){
                tmp = `P${tmpArr1[0]}Y${tmpArr2[0]}M0D`
            }else{
                tmp = `P${tmpArr1[0]}Y${tmpArr2[0]}M${date}D`
            }
        }
    }else{
        if(type === 1){
            tmp = `P${date}Y0M0D`
        }else if(type === 2){
            tmp = `P0Y${date}M0D`
        }else if(type === 3){
            tmp = `P0Y0M${date}D`
        }

    }
    props.changeCreateItemDateUse(tmp)
}

function viewGeologivDataValue(props){
    let tmp = null;
    if(props.auctionsMy.geologicDataValue !== null){
        tmp = props.auctionsMy.geologicDataValue.amount
    }
    return tmp
}

function viewDocumentationValue(props){
    let tmp = null;
    if(props.auctionsMy.documentationValue !== null){
        tmp = props.auctionsMy.documentationValue.amount
    }
    return tmp
}

function viewIdElements(props){
    let tmp = null;
    let tmpIdAuction = null;
    let tmpIdProcedure = null;
    if(props.auctionsMy){
        if(props.auctionsMy.auctionId !== null){
            tmpIdAuction = <div>ID аукціону Prozorro: <span>{props.auctionsMy.auctionId}</span></div>
        }
        if(props.auctionsMy.procedureId !== null){
            tmpIdProcedure = <div>ID процедури: <span>{props.auctionsMy.procedureId}</span></div>
        }
        tmp = <div>
            {tmpIdAuction}
            {tmpIdProcedure}
        </div>
    }
    return tmp
}

function viewWagonSelected(props){
    let tmp = null;
    switch(props.auctionsMy.sellingMethod){
        case "railwayCargo-english":
        case "railwayCargo-english-fast":
        case "railwayCargo-english-fast-manual":
        case "railwayCargo-english-initial-auction":
        case "railwayCargo-english-initial-qualification":
        case "railwayCargo-dutch":
        case "railwayCargo-dutch-fast":
        case "railwayCargo-dutch-fast-manual":
        case "railwayCargo-dutch-initial-auction":
        case "railwayCargo-dutch-initial-qualification":
        case "railwayCargo-dutch-fast-auction-manual-qualification":
        case "railwayCargo-dutch-initial-auction-manual":
            tmp = <div className={styles.groupElem}>
                    <div>
                        <TextField
                            disabled={disabledElement(props.auctionsMy, '01')}
                            id="outlined-select-currency-native"
                            select
                            label="Тип аукціону"
                            value={props.auctionsMy.carryType}
                            onChange={(event)=>{
                                props.setCarryType(event.target.value)
                            }}
                            SelectProps={{
                                native: true,
                            }}
                            helperText="Обрати тип аукціону"
                            variant="outlined"
                        >
                            <option key={0} selected disabled value='null'>Обрати</option>
                            {wagonTypeOption(props)}
                        </TextField>
                    </div>
                </div>
            break;
        default:
            break;
    }
    return tmp
}

function wagonTypeOption(props){
    let tmp = null;
    let tmpArr = null;
    if(props.carryType !== null){
        tmpArr = props.carryType.map(
            (i) => {
                return <option value={i.name}>{i.description.uk_UA}</option>
            }
        )
    }
    switch(props.auctionsMy.sellingMethod){
        case "railwayCargo-english":
        case "railwayCargo-english-fast":
        case "railwayCargo-english-fast-manual":
        case "railwayCargo-english-initial-auction":
        case "railwayCargo-english-initial-qualification":
        case "railwayCargo-dutch":
        case "railwayCargo-dutch-fast":
        case "railwayCargo-dutch-fast-manual":
        case "railwayCargo-dutch-initial-auction":
        case "railwayCargo-dutch-initial-qualification":
        case "railwayCargo-dutch-fast-auction-manual-qualification":
        case "railwayCargo-dutch-initial-auction-manual":
            tmp = tmpArr
            break;
        default:
            break;
    }
    return tmp
}

function addArrayBankAccounts(props, elem){
    let tmp = props.bankAccountIdArr;
    if(tmp !== null){
        if(tmp.length > 0){
            if(tmp.includes(Number(elem)) !== true){
                tmp.push(Number(elem))
                props.setPopBankAccountIdArr(tmp)
            }
        }else{
            tmp.push(Number(elem))
            props.setPopBankAccountIdArr(tmp)
        }
    }else{
        tmp = []
        tmp.push(Number(elem))
        props.setPopBankAccountIdArr(tmp)
    }
}

function elementDisabledCreate(props){
    let tmpStatus = null;
    if(props.auctionsMy.status !== null){
        if(props.auctionsMy.status !== 'active_rectification'){
            tmpStatus = 'disabled'
        }
    }
    return tmpStatus
}

function selectBankAuction(props){
    let tmp = null;
    if(props.bankAccount !== null){
        tmp = props.bankAccount
        .map(
            (i, count) => {
            return <option key={count+1} value={i.id}>{i.bankName}</option>
            }
        )
    }
    return tmp
}

function dateStartAuction(props, onOff){
    let tmp;
    if(onOff === null){
        if(props.auctionsMy.procedureId === null){
            tmp = <InputDate
                    data={{
                        target: props.auctionsMy.startDate,
                        time: true
                    }}
                    onChange={(e) => {
                                    props.changeCreateAuctionDateStart(e)
                    }}
                    />
        }else{
            tmp = <InputDate
            data={{
                target: props.auctionsMy.startDate,
                time: true
            }}
            onChange={(e) => {
                            props.changeCreateAuctionDateStart(e)
            }}
            />
        }

        if(props.auctionsSwitchWindow === 3){
            tmp = <InputDate
            data={{
                target: props.auctionsMy.startDate,
                time: true
            }}
            onChange={(e) => {
                            props.changeCreateAuctionDateStart(e)
            }}
            />
        }
    }else{
        tmp = <>
                <InputDate
                    data={{
                        target: props.auctionsMy.startDate,
                        time: true
                    }}
                    onChange={(e) => {
                                    props.changeCreateAuctionDateStart(e)
                    }}
                    disabled='disabled'
                />
            <div>Дата аукціону буде запланована автоматично: через 1 повний робочий день з моменту публікації</div>
        </>
    }
    return tmp
}


function createNew(props){
    let tmp = null;
    if(props.auctionsMy.sellingMethod !== null && props.auctionsMy.sellingMethod !== 'null'){
        tmp = (
            <Button
                disabled={checkingFilledFields(props, onOffCurrentTenat)}
                variant="contained"
                color="primary"
                onClick={() => {createAucNew1(props)}}
            >
                Створити аукціон
            </Button>
        )
    }
    return tmp
}

function createOrEdit(props){
    let tmp = null;
    if(props.auctionsSwitchWindow === 2 && (props.auctionsMy.sellingMethod !== null && props.auctionsMy.sellingMethod !== 'null')){
        tmp = (
            <Button
                disabled={checkingFilledFields(props, onOffCurrentTenat)}
                variant="contained"
                color="primary"
                onClick={
                    () => {
                        if(

                            props.auctionsMy.sellingMethod === 'alienation-english' ||
                            props.auctionsMy.sellingMethod === 'alienation-english-fast' ||
                            props.auctionsMy.sellingMethod === 'alienation-english-fast-manual' ||
                            props.auctionsMy.sellingMethod === 'alienation-english-fast-auction-manual-qualification' ||
                            props.auctionsMy.sellingMethod === 'alienation-english-initial-auction' ||
                            props.auctionsMy.sellingMethod === 'alienation-english-initial-auction-manual' ||
                            props.auctionsMy.sellingMethod === 'alienation-english-initial-qualification' ||
                            props.auctionsMy.sellingMethod === 'alienation-english-initial-qualification-prod' ||

                            props.auctionsMy.sellingMethod === 'commercialSell-english' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-english-fast' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-english-fast-manual' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-english-fast-auction-manual-qualification' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-english-initial-auction' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-english-initial-auction-manual' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-english-initial-qualification' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-english-initial-qualification-prod' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-dutch' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-dutch-fast' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-dutch-fast-manual' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-dutch-fast-auction-manual-qualification' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-auction' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-auction-manual' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-qualification' ||
                            props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-qualification-prod' ||

                            props.auctionsMy.sellingMethod === 'bankRuptcy-english' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-english-fast' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-english-fast-manual' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-english-fast-auction-manual-qualification' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-english-initial-auction' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-english-initial-auction-manual' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-english-initial-qualification' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-english-initial-qualification-prod' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-fast' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-fast-manual' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-fast-auction-manual-qualification' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-auction' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-auction-manual' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-qualification' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-qualification-prod' ||
                            props.auctionsMy.sellingMethod === 'bankRuptcy-withoutAuction' ||


                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english-ultra-fast' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english-fast' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english-fast-manual' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english-fast-auction-manual-qualification' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english-fast-auction-prod' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english-initial-auction' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english-initial-auction-manual' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english-initial-qualification' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-english-initial-qualification-prod' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch-ultra-fast' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch-fast' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch-fast-manual' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch-fast-auction-manual-qualification' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch-fast-auction-prod' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch-initial-auction' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch-initial-auction-manual' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch-initial-qualification' ||
                            props.auctionsMy.sellingMethod === 'regulationsPropertyLease-dutch-initial-qualification-prod' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english-ultra-fast' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english-fast' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english-fast-manual' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english-fast-auction-manual-qualification' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english-fast-auction-prod' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english-initial-auction' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english-initial-auction-manual' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english-initial-qualification' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-english-initial-qualification-prod' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch-ultra-fast' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch-fast' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch-fast-manual' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch-fast-auction-manual-qualification' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch-fast-auction-prod' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch-initial-auction' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch-initial-auction-manual' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch-initial-qualification' ||
                            props.auctionsMy.sellingMethod === 'commercialPropertyLease-dutch-initial-qualification-prod'
                        ){
                            createAucNew(props)
                        }else{
                            createAuc(props)
                        }
                    }
                }
            >
                Зберегти аукціон
            </Button>
        )
    }else if(props.auctionsSwitchWindow === 3){
        tmp = (
            <Button
                variant="contained"
                color="primary"
                onClick={
                    () => {
                        cloneAuc(props)
                    }
                }
            >
                Копіювання аукціону
            </Button>
        )
    }else if(props.auctionsSwitchWindow === 1 && (props.auctionsMy.sellingMethod !== null && props.auctionsMy.sellingMethod !== 'null')){
        tmp = (
            <Button
                disabled={checkingFilledFields(props, onOffCurrentTenat)}
                variant="contained"
                color="primary"
                onClick={
                    () => {
                        editAuc(props)
                    }
                }
            >
                Зберегти зміни
            </Button>
        )
    }
    return tmp
}

async function createDiscountForAuction(props, auctionId){
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/discount`
    if(props.auctionsMy.tenderAttempts > 1){
        if(
            props.auctionsMy.sellingMethod === 'basicSell-english' ||
            props.auctionsMy.sellingMethod === 'basicSell-english-fast' ||
            props.auctionsMy.sellingMethod === 'basicSell-english-fast-manual' ||
            props.auctionsMy.sellingMethod === 'basicSell-english-fast-auction-manual-qualification' ||
            props.auctionsMy.sellingMethod === 'basicSell-english-initial-auction' ||
            props.auctionsMy.sellingMethod === 'basicSell-english-initial-auction-manual' ||
            props.auctionsMy.sellingMethod === 'basicSell-english-initial-qualification' ||
            props.auctionsMy.sellingMethod === 'basicSell-english-initial-qualification-prod' ||
            props.auctionsMy.sellingMethod === 'basicSell-dutch' ||
            props.auctionsMy.sellingMethod === 'basicSell-dutch-fast' ||
            props.auctionsMy.sellingMethod === 'basicSell-dutch-fast-manual' ||
            props.auctionsMy.sellingMethod === 'basicSell-dutch-fast-auction-manual-qualification' ||
            props.auctionsMy.sellingMethod === 'basicSell-dutch-initial-auction' ||
            props.auctionsMy.sellingMethod === 'basicSell-dutch-initial-auction-manual' ||
            props.auctionsMy.sellingMethod === 'basicSell-dutch-initial-qualification' ||
            props.auctionsMy.sellingMethod === 'basicSell-dutch-initial-qualification-prod' ||
            props.auctionsMy.sellingMethod === 'alienation-english' ||
            props.auctionsMy.sellingMethod === 'alienation-english-fast' ||
            props.auctionsMy.sellingMethod === 'alienation-english-fast-manual' ||
            props.auctionsMy.sellingMethod === 'alienation-english-fast-auction-manual-qualification' ||
            props.auctionsMy.sellingMethod === 'alienation-english-initial-auction' ||
            props.auctionsMy.sellingMethod === 'alienation-english-initial-auction-manual' ||
            props.auctionsMy.sellingMethod === 'alienation-english-initial-qualification' ||
            props.auctionsMy.sellingMethod === 'alienation-english-initial-qualification-prod' ||
            props.auctionsMy.sellingMethod === 'commercialSell-english' ||
            props.auctionsMy.sellingMethod === 'commercialSell-english-fast' ||
            props.auctionsMy.sellingMethod === 'commercialSell-english-fast-manual' ||
            props.auctionsMy.sellingMethod === 'commercialSell-english-fast-auction-manual-qualification' ||
            props.auctionsMy.sellingMethod === 'commercialSell-english-initial-auction' ||
            props.auctionsMy.sellingMethod === 'commercialSell-english-initial-auction-manual' ||
            props.auctionsMy.sellingMethod === 'commercialSell-english-initial-qualification' ||
            props.auctionsMy.sellingMethod === 'commercialSell-english-initial-qualification-prod' ||
            props.auctionsMy.sellingMethod === 'commercialSell-dutch' ||
            props.auctionsMy.sellingMethod === 'commercialSell-dutch-fast' ||
            props.auctionsMy.sellingMethod === 'commercialSell-dutch-fast-manual' ||
            props.auctionsMy.sellingMethod === 'commercialSell-dutch-fast-auction-manual-qualification' ||
            props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-auction' ||
            props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-auction-manual' ||
            props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-qualification' ||
            props.auctionsMy.sellingMethod === 'commercialSell-dutch-initial-qualification-prod' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-english' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-english-fast' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-english-fast-manual' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-english-fast-auction-manual-qualification' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-english-initial-auction' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-english-initial-auction-manual' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-english-initial-qualification' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-english-initial-qualification-prod' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-fast' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-fast-manual' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-fast-auction-manual-qualification' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-auction' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-auction-manual' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-qualification' ||
            props.auctionsMy.sellingMethod === 'bankRuptcy-dutch-initial-qualification-prod' ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-english" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-english-fast" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-english-fast-manual" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-english-fast-auction-manual-qualification" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-english-fast-auction-prod" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-english-initial-qualification" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-english-initial-qualification-prod" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-english-initial-auction" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-english-initial-auction-manual" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-dutch" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-fast" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-fast-manual" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-fast-auction-manual-qualification" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-fast-auction-prod" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-initial-auction" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-initial-auction-manual" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-initial-qualification" ||
            props.auctionsMy.sellingMethod === "nonperformingLoans-dutch-initial-qualification-prod"
        ){
            if(props.discount.previousAuctionId !== '' && (props.discount.discountPercent !== '' && props.discount.discountPercent !== null && props.discount.discountPercent !== 0 && props.discount.discountPercent !== '0')){
                let body = {}
                body.discount = true
                if(props.discount.discountPercent !== '' && props.discount.discountPercent !== null){
                    body.discountPercent = props.discount.discountPercent
                }else{
                    body.discountPercent = '0'
                }
                if(props.discount.previousAuctionValue.amount !== '' && props.discount.previousAuctionValue.amount !== null){
                    body.previousAuctionValue = {}
                    body.previousAuctionValue.currency = 'UAH'
                    body.previousAuctionValue.amount = props.discount.previousAuctionValue.amount
                    if(props.discount.previousAuctionValue.valueAddedTaxIncluded !== '' && props.discount.previousAuctionValue.valueAddedTaxIncluded !== null){
                        if(props.discount.previousAuctionValue.valueAddedTaxIncluded === true || props.discount.previousAuctionValue.valueAddedTaxIncluded === 'true'){
                            body.previousAuctionValue.valueAddedTaxIncluded = true
                        }else{
                            body.previousAuctionValue.valueAddedTaxIncluded = false
                        }
                    }else{
                        body.previousAuctionValue.valueAddedTaxIncluded = true
                    }
                }
                const response = await fetch(endPoint, {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: getDefaultHeaders(props)
                }).catch(console.error)
                if(response === undefined || response === 'undefined'){
                }else{
                    const json = await response.json()
                    if(json.hasOwnProperty('message') === true){
                        let tmp = JSON.stringify({title: 'Помилка при створенні знижки', message: JSON.stringify(json)})
                        props.setUniversalError(tmp)
                    }else{
                        props.changeDiscountPreviousAuctionCurrency('null')
                        props.changeDiscountPreviousAuctionAmount('')
                        props.changeDiscountPercent('')
                        props.changeDiscountPreviousAuctionId('')
                    }
                }
            }
        }else if(
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-fast" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-fast-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-fast-auction-manual-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-auction" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-auction-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-qualification-prod" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast-auction-manual-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-auction" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-auction-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-qualification-prod"
        ){
                let body = {}
                body.discount = true
                body.discountPercent = props.discount.discountPercent
                let tmpDisAmount = null
                if(props.discount.previousAuctionValue.amount !== '') tmpDisAmount = props.discount.previousAuctionValue.amount
                body.previousAuctionValue = {
                    currency: 'UAH',
                    amount: tmpDisAmount
                }
                const response = await fetch(endPoint, {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: getDefaultHeaders(props)
                }).catch(console.error)
                if(response === undefined || response === 'undefined'){
                }else{
                    const json = await response.json()
                    if(json.hasOwnProperty('message') === true){
                        let tmp = JSON.stringify({title: 'Помилка при створенні знижки', message: JSON.stringify(json)})
                        props.setUniversalError(tmp)
                    }else{
                        props.changeDiscountPreviousAuctionCurrency('null')
                        props.changeDiscountPreviousAuctionAmount('')
                        props.changeDiscountPercent('')
                        props.changeDiscountPreviousAuctionId('')
                        
                    }
                }
            //}
        }else{
            if(props.discount.previousAuctionId !== ''){
                if(props.discount.discountPercent !== ''){
                    let body
                    if(props.discount.discountOnOff === false){
                        body = {
                            discount: false,
                        }
                    }else{
                        if(props.discount.discountPercent !== ''){
                            let tmpDisAmount = null
                            if(props.discount.previousAuctionValue.amount !== '') tmpDisAmount = props.discount.previousAuctionValue.amount
                            body = {
                                discount: true,
                                discountPercent: props.discount.discountPercent,
                                previousAuctionValue: {
                                    currency: 'UAH',
                                    amount: tmpDisAmount,
                                }
                            }
                        }else{
                            let tmpDisAmount = null
                            if(props.discount.previousAuctionValue.amount !== '') tmpDisAmount = props.discount.previousAuctionValue.amount
                            body = {
                                discount: true,
                                discountPercent: '0',
                                previousAuctionValue: {
                                    currency: 'UAH',
                                    amount: tmpDisAmount,
                                }
                            }
                        }
                    }
                    const response = await fetch(endPoint, {
                        method: "POST",
                        body: JSON.stringify(body),
                        headers: getDefaultHeaders(props)
                    }).catch(console.error)
                    if(response === undefined || response === 'undefined'){
                    }else{
                        const json = await response.json()
                        if(json.hasOwnProperty('message') === true){
                            let tmp = JSON.stringify({title: 'Помилка при створенні знижки', message: JSON.stringify(json)})
                            props.setUniversalError(tmp)
                        }else{
                            props.changeDiscountPreviousAuctionCurrency('null')
                            props.changeDiscountPreviousAuctionAmount('')
                            props.changeDiscountPercent('')
                            props.changeDiscountPreviousAuctionId('')
                        }
                    }
                }
            }
        }
    }
}

async function editDiscountForAuction(props, auctionId){
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/discount`
    if(props.auctionsMy.tenderAttempts > 1){
        if(props.discount.previousAuctionId !== ''){
            if(props.discount.discountPercent !== ''){
                let body
                if(props.discount.discountOnOff === false){
                    body = {
                        discount: false,
                    }
                }else{
                    if(props.discount.discountPercent !== ''){
                        let tmpDisAmount = null
                        if(props.discount.previousAuctionValue.amount !== '') tmpDisAmount = props.discount.previousAuctionValue.amount
                        body = {
                            discount: true,
                            discountPercent: props.discount.discountPercent,
                            previousAuctionValue: {
                                currency: 'UAH',
                                amount: tmpDisAmount,
                            }
                        }
                    }else{
                        let tmpDisAmount = null
                        if(props.discount.previousAuctionValue.amount !== '') tmpDisAmount = props.discount.previousAuctionValue.amount
                        body = {
                            discount: true,
                            discountPercent: '0',
                            previousAuctionValue: {
                                currency: 'UAH',
                                amount: tmpDisAmount,
                            }
                        }
                    }
                }
                const response = await fetch(endPoint, {
                    method: "PUT",
                    body: JSON.stringify(body),
                    headers: getDefaultHeaders(props)
                }).catch(console.error)
                if(response === undefined || response === 'undefined'){
                }else{
                    const json = await response.json()
                    if(json.hasOwnProperty('message') === true){
                        let tmp = JSON.stringify({title: 'Помилка при створенні знижки', message: JSON.stringify(json)})
	                    props.setUniversalError(tmp)
                    }else{
                        props.changeDiscountPreviousAuctionCurrency('null')
                        props.changeDiscountPreviousAuctionAmount('')
                        props.changeDiscountPercent('')
                        props.changeDiscountPreviousAuctionId('')
                    }
                }
            }
        }
    }
}

async function createAucNew1(props){
    let tmpBody
    tmpBody = {
        sellingMethod: props.auctionsMy.sellingMethod + props.auctionsMy.sellingMethodPrefix
    }
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v2/uk/private/auction-draft`;
    const response = await fetch(endPoint, {
        method: "POST",
        body: JSON.stringify(tmpBody),
        headers: getDefaultHeaders(props)
    }).catch(console.error)

    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: 'Помилка при створенні аукціону', message: JSON.stringify(json)})
	        props.setUniversalError(tmp)
        }else{
            props.setDataAddress([], 'SET_POP_UP_BANK_ACCOUNT_ZU')
            props.setDataAddress(json, 'POPUP_AUCTION_MONGA')
        }
    }
}


async function createAucNew(props){
    let tmpBody
    let bodyObj = {
        base: props.auctionsMy,
        bank: props.bankAccountWork,
        bankList: props.bankAccount,
        bankAccountZU: props.bankAccountZU,
        deleteBankGroops: props.deleteBankGroops,
        deleteCurentBank: props.deleteCurentBank,
        discount: props.discount,
    }
    tmpBody = createBody(bodyObj)
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v2/uk/private/auction-draft`;
    const response = await fetch(endPoint, {
        method: "POST",
        body: JSON.stringify(tmpBody),
        headers: getDefaultHeaders(props)
    }).catch(console.error)

    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: 'Помилка при створенні аукціону', message: JSON.stringify(json)})
	        props.setUniversalError(tmp)
        }else{
            props.setDataAddress([], 'SET_POP_UP_BANK_ACCOUNT_ZU')
            props.setDataAddress(json, 'POPUP_AUCTION_MONGA')
        }
    }
}


async function createAuc(props){
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/auction`;
    let tmpPreviousAuctionId = null;
    if(props.auctionsMy.tenderAttempts !== 1){
        if(props.discount.previousAuctionId !== ''){
            tmpPreviousAuctionId = props.discount.previousAuctionId
        }
    }
    let tmpDocumentationValue = null;
    let tmpGeologivDataValue = null;
    let tmpGuarantee;
    let tmpMinStep;
    let tmpValue;
    switch(props.auctionsMy.sellingMethod){
        case "subsoil-english":
        case "subsoil-english-fast":
        case "subsoil-english-fast-manual":
        case "subsoil-english-initial-auction":
        case "subsoil-english-initial-qualification":
        case "subsoil-dutch":
        case "subsoil-dutch-fast":
        case "subsoil-dutch-fast-manual":
        case "subsoil-dutch-initial-auction":
        case "subsoil-dutch-initial-qualification":
        case "subsoil-dutch-initial-auction-manual":
        case "subsoil-english-fast-auction-manual-qualification":
            tmpDocumentationValue = {currency: 'UAH', amount: props.auctionsMy.documentationValue.amount}
            tmpGeologivDataValue = {currency: 'UAH', amount: Number(props.auctionsMy.geologicDataValue.amount)}
            tmpGuarantee = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.guarantee.amount),
            }
            tmpMinStep = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.minimalStep.amount),
            }
            tmpValue = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.value.amount),
            }
            break;
        case "timber-english":
        case "timber-english-fast":
        case "timber-english-fast-manual":
        case "timber-english-initial-auction":
        case "timber-english-initial-qualification":
        case "timber-english-initial-qualification-fast":
        case "railwayCargo-english":
        case "railwayCargo-english-fast":
        case "railwayCargo-english-fast-manual":
        case "railwayCargo-english-initial-auction":
        case "railwayCargo-english-initial-qualification":
        case "railwayCargo-dutch":
        case "railwayCargo-dutch-fast":
        case "railwayCargo-dutch-fast-manual":
        case "railwayCargo-dutch-initial-auction":
        case "railwayCargo-dutch-initial-qualification":
        case "railwayCargo-dutch-fast-auction-manual-qualification":
        case "railwayCargo-dutch-initial-auction-manual":
        case "dgf-english":
        case "dgf-english-fast":
        case "dgf-english-fast-manual":
        case "dgf-english-fast-auction-manual-qualification":
        case "dgf-english-initial-auction":
        case "dgf-english-initial-auction-manual":
        case "dgf-english-initial-qualification":
        case "dgf-dutch":
        case "dgf-dutch-fast":
        case "dgf-dutch-fast-manual":
        case "dgf-dutch-fast-auction-manual-qualification":
        case "dgf-dutch-initial-auction":
        case "dgf-dutch-initial-qualification":
        case "dgf-dutch-initial-auction-manual":
        case "legitimatePropertyLease-english":
        case "legitimatePropertyLease-english-fast":
        case "legitimatePropertyLease-english-fast-manual":
        case "legitimatePropertyLease-english-fast-auction-manual-qualification":
        case "legitimatePropertyLease-english-initial-auction":
        case "legitimatePropertyLease-english-initial-auction-manual":
        case "legitimatePropertyLease-english-initial-qualification":
        case "legitimatePropertyLease-english-initial-qualification-prod":
        case "legitimatePropertyLease-dutch":
        case "legitimatePropertyLease-dutch-fast":
        case "legitimatePropertyLease-dutch-fast-manual":
        case "legitimatePropertyLease-dutch-fast-auction-manual-qualification":
        case "legitimatePropertyLease-dutch-initial-auction":
        case "legitimatePropertyLease-dutch-initial-auction-manual":
        case "legitimatePropertyLease-dutch-initial-qualification-prod":
        case "legitimatePropertyLease-priorityEnglish":
        case "legitimatePropertyLease-priorityEnglish-fast":
        case "legitimatePropertyLease-priorityEnglish-fast-manual":
        case "legitimatePropertyLease-priorityEnglish-fast-auction-manual-qualification":
        case "legitimatePropertyLease-priorityEnglish-initial-auction":
        case "legitimatePropertyLease-priorityEnglish-initial-auction-manual":
        case "legitimatePropertyLease-priorityEnglish-initial-qualification":
        case "legitimatePropertyLease-priorityEnglish-initial-qualification-prod":
        case 'landRental-english':
        case 'landRental-english-fast':
        case 'landRental-english-fast-manual':
        case 'landRental-english-fast-auction-manual-qualification':
        case 'landRental-english-initial-auction':
        case 'landRental-english-initial-auction-manual':
        case 'landRental-english-initial-qualification':
        case 'landRental-english-initial-qualification-prod':
        case 'landSell-english':
        case 'landSell-english-fast':
        case 'landSell-english-fast-manual':
        case 'landSell-english-fast-auction-manual-qualification':
        case 'landSell-english-initial-auction':
        case 'landSell-english-initial-auction-manual':
        case 'landSell-english-initial-qualification':
        case 'landSell-english-initial-qualification-prod':
        case 'landSell-priorityEnglish':
        case 'landSell-priorityEnglish-fast':
        case 'landSell-priorityEnglish-fast-manual':
        case 'landSell-priorityEnglish-fast-auction-manual-qualification':
        case 'landSell-priorityEnglish-initial-auction':
        case 'landSell-priorityEnglish-initial-auction-manual':
        case 'landSell-priorityEnglish-initial-qualification':
        case 'landSell-priorityEnglish-initial-qualification-prod':
            tmpGuarantee = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.guarantee.amount),
            }
            tmpMinStep = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.minimalStep.amount),
            }
            let tmpValueAddedTaxIncluded = null
            if(props.auctionsMy.value.valueAddedTaxIncluded === 'false'){
                tmpValueAddedTaxIncluded = false
            }else{
                tmpValueAddedTaxIncluded = true
            }
            tmpValue = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.value.amount),
                valueAddedTaxIncluded: tmpValueAddedTaxIncluded,
            }
            break
        default:
            tmpGuarantee = {
                currency: props.auctionsMy.guarantee.currency,
                amount: Number(props.auctionsMy.guarantee.amount),
            }
            tmpMinStep = {
                currency: props.auctionsMy.minimalStep.currency,
                amount: Number(props.auctionsMy.minimalStep.amount),
            }
            tmpValue = {
                currency: props.auctionsMy.value.currency,
                amount: Number(props.auctionsMy.value.amount),
            }
            break;
    }



    let minNumberOfQualifiedBids = returnDataRailway(props)
    if(minNumberOfQualifiedBids === 'null') minNumberOfQualifiedBids = null

    let tmpBody = {}

    if (procedure.isLLE(props.auctionsMy.sellingMethod)) {
        if(props.auctionsMy.hasOwnProperty('currentTenantGuaranteeFee') === true){
            if(props.auctionsMy.currentTenantGuaranteeFee.amount !== ''){
                tmpBody.currentTenantGuaranteeFee = {
                    currency: 'UAH',
                    amount: Number(props.auctionsMy.currentTenantGuaranteeFee.amount)
                }
            }
        }
        if(tmpBody.hasOwnProperty('currentTenantGuaranteeFee') !== true) tmpBody.currentTenantGuaranteeFee = null
    }

    tmpBody.documentationValue = tmpDocumentationValue
    tmpBody.geologicDataValue = tmpGeologivDataValue
    tmpBody.leaseDuration = props.auctionsMy.leaseDuration
    if(
        procedure.isLRE(props.auctionsMy.sellingMethod)
        || procedure.isLSE(props.auctionsMy.sellingMethod)
        || procedure.isLSP(props.auctionsMy.sellingMethod)
    ){
        tmpBody.carryTypeId = props.auctionsMy.carryType
    }

    tmpBody.previousAuctionId = tmpPreviousAuctionId
    tmpBody.title = props.auctionsMy.title
    tmpBody.description = props.auctionsMy.description
    if (procedure.isSUE(props.auctionsMy.sellingMethod) || procedure.isSUD(props.auctionsMy.sellingMethod)) {
        tmpBody.bankAccountIds = createArrBanks(props, 1, props.auctionsMy.id)
    }
    tmpBody.sellingMethod = props.auctionsMy.sellingMethod
    tmpBody.tenderAttempts = props.auctionsMy.tenderAttempts
    if(props.auctionsMy.accessDetails !== null && props.auctionsMy.accessDetails !== ''){
        tmpBody.accessDetails = props.auctionsMy.accessDetails
    }
    if (
        procedure.isLLE(props.auctionsMy.sellingMethod)
        || procedure.isLLD(props.auctionsMy.sellingMethod)
        || procedure.isLLP(props.auctionsMy.sellingMethod)
    ) {
        tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
    }else{
        tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
        if(props.auctionsMy.xDocumentRequirements !== null && props.auctionsMy.xDocumentRequirements !== ''){
            tmpBody.xDocumentRequirements = props.auctionsMy.xDocumentRequirements
        }
    }

    if(props.auctionsMy.xAdditionalInformation !== null && props.auctionsMy.xAdditionalInformation !== ''){
        tmpBody.xAdditionalInformation = props.auctionsMy.xAdditionalInformation
    }
    tmpBody.value = tmpValue
    tmpBody.guarantee = tmpGuarantee
    tmpBody.minimalStep = tmpMinStep
    tmpBody.minNumberOfQualifiedBids = minNumberOfQualifiedBids
    let tmpOldAuctionStartDate = props.auctionsMy.startDate
    if(
        tmpOldAuctionStartDate !== null &&
        tmpOldAuctionStartDate !== ''
    ){
        tmpOldAuctionStartDate = new Date(tmpOldAuctionStartDate)
        if(Date.now() < tmpOldAuctionStartDate.getTime()){
            tmpBody.startDate = props.auctionsMy.startDate
        }
    }
    tmpBody.documents = props.auctionsMy.documents

    switch(true){
        case props.auctionsMy.sellingMethod.includes('dgf-english'):
        case props.auctionsMy.sellingMethod.includes('dgf-dutch'):
            tmpBody.minNumberOfQualifiedBids = props.auctionsMy.minNumberOfQualifiedBids
            tmpBody.virtualDataRoom = props.auctionsMy.virtualDataRoom
            tmpBody.eligibilityCriteria = props.auctionsMy.eligibilityCriteria
            tmpBody.decision = {
                decisionId: props.auctionsMy.decision.decisionId,
                decisionDate: props.auctionsMy.decision.decisionDate
            }
            tmpBody.x_dgfPlatformLegalDetails = props.auctionsMy.x_dgfPlatformLegalDetails
            break;
        case props.auctionsMy.sellingMethod.includes('legitimatePropertyLease-english'):
        case props.auctionsMy.sellingMethod.includes('legitimatePropertyLease-dutch'):
        case props.auctionsMy.sellingMethod.includes('priorityEnglish-dutch'):
            if(Number(props.auctionsMy.minNumberOfQualifiedBids) === 1 || Number(props.auctionsMy.minNumberOfQualifiedBids) === 2){
                tmpBody.minNumberOfQualifiedBids = Number(props.auctionsMy.minNumberOfQualifiedBids)
            }else{
                tmpBody.minNumberOfQualifiedBids = 1
            }
            tmpBody.calcOnBookValue = props.auctionsMy.calcOnBookValue
            tmpBody.valueAddedTaxCharged = props.auctionsMy.valueAddedTaxCharged
            tmpBody.registryId = props.auctionsMy.registryId
                tmpBody.registrationFee = {
                    currency: 'UAH',
                    amount: Number(props.auctionsMy.registrationFee.amount),
                }
            //}
            tmpBody.valuePeriod = props.auctionsMy.valuePeriod
            break;
        case props.auctionsMy.sellingMethod.includes('landRental-english'):
        case props.auctionsMy.sellingMethod.includes('landSell-english'):
        case props.auctionsMy.sellingMethod.includes('landSell-priorityEnglish'):
            if(props.auctionsMy.xDgfPlatformLegalDetails !== null && props.auctionsMy.xDgfPlatformLegalDetails !== '') tmpBody.xDgfPlatformLegalDetails = props.auctionsMy.xDgfPlatformLegalDetails
            if(props.auctionsMy.registrationFee !== null){
                if(props.auctionsMy.registrationFee.valueAddedTaxIncluded === true || props.auctionsMy.registrationFee.valueAddedTaxIncluded === 'true'){
                    if(props.auctionsMy.registrationFee.amount !== null && props.auctionsMy.registrationFee.amount !== ''){
                        tmpBody.registrationFee = {
                            currency: 'UAH',
                            amount: Number(props.auctionsMy.registrationFee.amount),
                            valueAddedTaxIncluded: true
                        }
                    }else{
                        tmpBody.registrationFee = {
                            currency: 'UAH',
                            amount: 0.01,
                            valueAddedTaxIncluded: true
                        }
                    }
                }else if(props.auctionsMy.registrationFee.valueAddedTaxIncluded === false || props.auctionsMy.registrationFee.valueAddedTaxIncluded === 'false'){
                    if(props.auctionsMy.registrationFee.amount !== null && props.auctionsMy.registrationFee.amount !== ''){
                        tmpBody.registrationFee = {
                            currency: 'UAH',
                            amount: Number(props.auctionsMy.registrationFee.amount),
                            valueAddedTaxIncluded: false
                        }
                    }else{
                        tmpBody.registrationFee = {
                            currency: 'UAH',
                            amount: 0.01,
                            valueAddedTaxIncluded: false
                        }
                    }
                }else{
                    if(props.auctionsMy.registrationFee.amount !== null && props.auctionsMy.registrationFee.amount !== ''){
                        tmpBody.registrationFee = {
                            currency: 'UAH',
                            amount: Number(props.auctionsMy.registrationFee.amount),
                        }
                    }else{
                        tmpBody.registrationFee = {
                            currency: 'UAH',
                            amount: 0.01,
                            valueAddedTaxIncluded: false
                        }
                    }
                }
            }
            if( procedure.isLSP(props.auctionsMy.sellingMethod) ){
                if(props.auctionsMy.hasOwnProperty("numberOfCurrentTenants") === true && props.auctionsMy.numberOfCurrentTenants !== 'null' && props.auctionsMy.numberOfCurrentTenants !== null){
                    tmpBody.numberOfCurrentTenants = props.auctionsMy.numberOfCurrentTenants
                    if(props.auctionsMy.hasOwnProperty("currentTenant") === true  && props.auctionsMy.currentTenant !== 0){
                        tmpBody.currentTenants = props.auctionsMy.currentTenant.currentTenants
                    }else{
                        tmpBody.currentTenants = null
                    }
                }else{
                    tmpBody.numberOfCurrentTenants = 1
                    if(props.auctionsMy.hasOwnProperty("currentTenant") === true && props.auctionsMy.currentTenant !== 0){
                        tmpBody.currentTenants = props.auctionsMy.currentTenant.currentTenants
                    }else{
                        tmpBody.currentTenants = null
                    }
                }
            }
            if(props.auctionsMy.leaseType !== 'null' && props.auctionsMy.leaseType !== null){
                if(props.auctionsMy.leaseType === 'saleOrLeaseType'){
                    tmpBody.leaseType = 'landRental'
                }else{
                    if(
                        props.auctionsMy.sellingMethod === 'landRental-english' ||
                        props.auctionsMy.sellingMethod === 'landRental-english-fast' ||
                        props.auctionsMy.sellingMethod === 'landRental-english-fast-manual' ||
                        props.auctionsMy.sellingMethod === 'landRental-english-fast-auction-manual-qualification' ||
                        props.auctionsMy.sellingMethod === 'landRental-english-initial-auction' ||
                        props.auctionsMy.sellingMethod === 'landRental-english-initial-auction-manual' ||
                        props.auctionsMy.sellingMethod === 'landRental-english-initial-qualification' ||
                        props.auctionsMy.sellingMethod === 'landRental-english-initial-qualification-prod'
                    ){
                        tmpBody.leaseType = 'landRental'
                    }
                }
            }
            if(props.auctionsMy.saleType !== 'null' && props.auctionsMy.saleType !== null){
                tmpBody.saleType = props.auctionsMy.saleType
            }
            if(props.auctionsMy.hasOwnProperty('normativeMonetaryValuation') === true){
                if(props.auctionsMy.normativeMonetaryValuation !== null){
                    if(props.auctionsMy.normativeMonetaryValuation.amount !== null && props.auctionsMy.normativeMonetaryValuation.amount !== ''){
                        tmpBody.normativeMonetaryValuation = {
                            current: 'UAH',
                            amount: Number(props.auctionsMy.normativeMonetaryValuation.amount)
                        }
                    }
                }
            }
            if(tmpBody.hasOwnProperty('normativeMonetaryValuation') !== true) tmpBody.normativeMonetaryValuation = null

            if(props.auctionsMy.hasOwnProperty('expertMonetaryValuation') === true){
                if(props.auctionsMy.expertMonetaryValuation !== null){
                    if(props.auctionsMy.expertMonetaryValuation.amount !== null && props.auctionsMy.expertMonetaryValuation.amount !== ''){
                        tmpBody.expertMonetaryValuation = {
                            current: 'UAH',
                            amount: Number(props.auctionsMy.expertMonetaryValuation.amount)
                        }
                    }
                }
            }
            if(tmpBody.hasOwnProperty('expertMonetaryValuation') !== true) tmpBody.expertMonetaryValuation = null

            if(props.auctionsMy.hasOwnProperty('budgetSpent') === true){
                if(props.auctionsMy.budgetSpent !== null){
                    if(props.auctionsMy.budgetSpent.amount !== null && props.auctionsMy.budgetSpent.amount !== ''){
                        tmpBody.budgetSpent = {
                            current: 'UAH',
                            amount: Number(props.auctionsMy.budgetSpent.amount)
                        }
                    }
                }
            }
            if(tmpBody.hasOwnProperty('budgetSpent') !== true) tmpBody.budgetSpent = null

            if(props.auctionsMy.conditions !== 'null' && props.auctionsMy.conditions !== null && props.auctionsMy.conditions !== ''){
                tmpBody.conditions = props.auctionsMy.conditions
            }
            if(props.auctionsMy.restrictions !== 'null' && props.auctionsMy.restrictions !== null && props.auctionsMy.restrictions !== ''){
                tmpBody.restrictions = props.auctionsMy.restrictions
            }
            break;
        default:
            break;
    }

    if(procedure.isSUE(props.auctionsMy.sellingMethod) || procedure.isSUD(props.auctionsMy.sellingMethod)) delete tmpBody.xAdditionalInformation

    //TODO: Подключаю новую сборку боди
    let tmpBody2
    if(
        procedure.isTIE(props.auctionsMy.sellingMethod) ||
        procedure.isSUE(props.auctionsMy.sellingMethod) ||
        procedure.isSUD(props.auctionsMy.sellingMethod) ||
        procedure.isRCE(props.auctionsMy.sellingMethod) ||
        procedure.isRCD(props.auctionsMy.sellingMethod) ||
        procedure.isLRE(props.auctionsMy.sellingMethod) ||
        procedure.isLSE(props.auctionsMy.sellingMethod) ||
        procedure.isLSP(props.auctionsMy.sellingMethod) ||

        procedure.isBSE(props.auctionsMy.sellingMethod) || procedure.isBSD(props.auctionsMy.sellingMethod) ||
        procedure.isALE(props.auctionsMy.sellingMethod) ||
        procedure.isCSE(props.auctionsMy.sellingMethod) || procedure.isCSD(props.auctionsMy.sellingMethod) ||
        procedure.isBRE(props.auctionsMy.sellingMethod) || procedure.isBRD(props.auctionsMy.sellingMethod) || procedure.isBRW(props.auctionsMy.sellingMethod) ||
        procedure.isSPE(props.auctionsMy.sellingMethod) || procedure.isSPD(props.auctionsMy.sellingMethod) ||
        procedure.isNLE(props.auctionsMy.sellingMethod) || procedure.isNLD(props.auctionsMy.sellingMethod) ||
        procedure.isLAE(props.auctionsMy.sellingMethod) || procedure.isLAW(props.auctionsMy.sellingMethod) || procedure.isLAP(props.auctionsMy.sellingMethod) ||
        procedure.isLPE(props.auctionsMy.sellingMethod)
        || procedure.isAPE(props.auctionsMy.sellingMethod) || procedure.isAPD(props.auctionsMy.sellingMethod)
        || procedure.isLLE(props.auctionsMy.sellingMethod) || procedure.isLLD(props.auctionsMy.sellingMethod)
    ){
        let bodyObj = {
            base: props.auctionsMy,
            bank: props.bankAccountWork,
            bankList: props.bankAccount,
            bankAccountZU: props.bankAccountZU,
            deleteBankGroops: props.deleteBankGroops,
            deleteCurentBank: props.deleteCurentBank,
            discount: props.discount,
        }
        // console.log(tmpBody)
        tmpBody2 = createBodyOld(bodyObj)
    }else{
        tmpBody2 = tmpBody
    }
    if (props.auctionsMy.sellingMethod.includes('railwayCargo-english') ||
        props.auctionsMy.sellingMethod.includes('railwayCargo-dutch')
    ) {
        tmpBody2.registrationFee = {
            currency: 'UAH',
            amount: Number(props.auctionsMy.registrationFee.amount),
        }
    }

    const response = await fetch(endPoint, {
        method: "POST",
        //timberEnglish
        body: JSON.stringify(tmpBody2),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: 'Помилка при створенні аукціону', message: JSON.stringify(json)})
	        props.setUniversalError(tmp)

        }else{
            if(
                props.auctionsMy.sellingMethod.startsWith('landRental-english') ||
                props.auctionsMy.sellingMethod.startsWith('landSell-english') ||
                props.auctionsMy.sellingMethod.startsWith('landSell-priorityEnglish') ||
                props.auctionsMy.sellingMethod.startsWith('basicSell-english') ||
                props.auctionsMy.sellingMethod.startsWith('basicSell-dutch') ||
                props.auctionsMy.sellingMethod.startsWith('alienation-english') ||
                props.auctionsMy.sellingMethod.startsWith('commercialSell-english') ||
                props.auctionsMy.sellingMethod.startsWith('commercialSell-dutch') ||
                props.auctionsMy.sellingMethod.startsWith('bankRuptcy-english') ||
                props.auctionsMy.sellingMethod.startsWith('bankRuptcy-dutch') ||
                props.auctionsMy.sellingMethod.startsWith('nonperformingLoans-english') ||
                props.auctionsMy.sellingMethod.startsWith('nonperformingLoans-dutch')
            ){
                createArrBanksLR(props, 2, json.id)
                if (props.auctionsMy.sellingMethod.includes('-dutch')) {
                    createDutch(props, json.id)
                }
            }
            if(
                props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-english" )||
                props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-dutch" )||
                props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish" )
            ){
                createAuctionLeaseRules(props, json.id)
            }
            if (props.auctionsMy.sellingMethod.startsWith("railwayCargo-dutch")) {
                if(
                    dutchData(props) !== false &&
                    !props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-english") &&
                    !props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish")
                ){
                    let dutchStep = {}
                    dutchStep.dutchStepValue = {}
                    if(props.auctionsMy.dutchStep.dutchStepQuantity === 'null'){
                        dutchStep.dutchStepQuantity = 1
                    }else{
                        dutchStep.dutchStepQuantity = props.auctionsMy.dutchStep.dutchStepQuantity
                    }
                    dutchStep.dutchStepValue.currency = 'UAH'
                    if (props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-dutch")) {
                        dutchStep.dutchStepPercent = 1
                        dutchStep.dutchStepValue.amount = props.auctionsMy.value.amount/100
                    }else{
                        dutchStep.dutchStepPercent = props.auctionsMy.dutchStep.dutchStepPercent
                        dutchStep.dutchStepValue.amount = props.auctionsMy.dutchStep.dutchStepValue.amount
                    }
                    const endPoint3 = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${json.id}/dutch_step`
                    const response3 = await fetch(endPoint3, {
                        method: "POST",
                        body: JSON.stringify(dutchStep),
                        headers: getDefaultHeaders(props)
                    }).catch(console.error)
                    if(response3 === undefined || response3 === 'undefined'){
                    }else{
                        const json3 = await response3.json()
                        if(json3.hasOwnProperty('message') === true){
                            let tmp = JSON.stringify({title: 'Помилка при створенні даних голандського аукціону', message: JSON.stringify(json3)})
                            props.setUniversalError(tmp)
                            //props.setPopUpAuctionCreate(1)
                        }else{
                            let tmpAucData = json
                            tmpAucData.dutchStep = json3
                            //props.setPopUpAuctionCreate(json)
                            props.setPopUpAuctionCreate(tmpAucData)
                            createDiscountForAuction(props, json.id)
                            props.changeDiscountPreviousAuctionCurrency('null')
                            props.changeDiscountPreviousAuctionAmount('')
                            props.changeDiscountPercent('')
                            props.changeDiscountPreviousAuctionId('')
                            props.discountAuc(false)
                        }
                    }
                }else{
                    props.setPopUpAuctionCreate(json)
                    createDiscountForAuction(props, json.id)
                    props.changeDiscountPreviousAuctionCurrency('null')
                    props.changeDiscountPreviousAuctionAmount('')
                    props.changeDiscountPercent('')
                    props.changeDiscountPreviousAuctionId('')
                    props.discountAuc(false)
                }
            }else{
                props.setPopUpAuctionCreate(json)
                createDiscountForAuction(props, json.id)
                props.changeDiscountPreviousAuctionCurrency('null')
                props.changeDiscountPreviousAuctionAmount('')
                props.changeDiscountPercent('')
                props.changeDiscountPreviousAuctionId('')
                props.discountAuc(false)
            }
        }
    }
    props.setDataAddress([], 'SET_POP_UP_BANK_ACCOUNT_ZU')
}

async function createDutch(props, aucId){
    if(
        props.auctionsMy.sellingMethod.startsWith("basicSell-dutch") ||
        props.auctionsMy.sellingMethod.startsWith("commercialSell-dutch") ||
        props.auctionsMy.sellingMethod.startsWith("bankRuptcy-dutch") ||
        props.auctionsMy.sellingMethod.startsWith("nonperformingLoans-dutch")
    ){
        let dutchStep = {}
        dutchStep.dutchStepValue = {}
        if(props.auctionsMy.dutchStep !== null){
            if(props.auctionsMy.dutchStep.dutchStepQuantity === null || props.auctionsMy.dutchStep.dutchStepQuantity === 'null'){
                dutchStep.dutchStepQuantity = 1
            }else{
                dutchStep.dutchStepQuantity = props.auctionsMy.dutchStep.dutchStepQuantity
            }
        }
        dutchStep.dutchStepValue.currency = 'UAH'
        if(props.auctionsMy.dutchStep !== null && props.auctionsMy.dutchStep !== ''){
            dutchStep.dutchStepPercent = props.auctionsMy.dutchStep.dutchStepPercent
            if(props.auctionsMy.dutchStep.dutchStepValue !== null){
                dutchStep.dutchStepValue.amount = props.auctionsMy.dutchStep.dutchStepValue.amount
            }
        }
        const endPoint3 = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${aucId}/dutch_step`
        const response3 = await fetch(endPoint3, {
            method: "POST",
            body: JSON.stringify(dutchStep),
            headers: {
                'Authorization': props.token.access_token,
                'Content-Type': 'application/json'
            }
        }).catch(console.error)
        if(response3 === undefined || response3 === 'undefined'){
        }else{
            const json3 = await response3.json()
            if(json3.hasOwnProperty('message') === true){
                let tmp = JSON.stringify({title: 'Помилка при редагуванні аукціону', message: JSON.stringify(json3)})
                props.setUniversalError(tmp)
            }else{

                //let tmpAucData = json
                //tmpAucData.dutchStep = json3
                //props.setPopUpAuctionCreate(tmpAucData)
            }
        }
    }
}

///////////////////////////////////////////////
///////////////////////////////////////////////
function createArrBanksLR(props, type, aucId){
    if(
        props.auctionsMy.sellingMethod.startsWith('landRental-english') ||
        props.auctionsMy.sellingMethod.startsWith('english-priorityEnglish')
    ){
        if(type === 2){
            createZUBanksLR(props, aucId)
        }
    }else if(
        props.auctionsMy.sellingMethod.startsWith('basicSell-english') ||
        props.auctionsMy.sellingMethod.startsWith('basicSell-dutch') ||
        props.auctionsMy.sellingMethod.startsWith('alienation-english') ||
        props.auctionsMy.sellingMethod.startsWith('commercialSell-english') ||
        props.auctionsMy.sellingMethod.startsWith('commercialSell-dutch') ||
        props.auctionsMy.sellingMethod.startsWith('bankRuptcy-english') ||
        props.auctionsMy.sellingMethod.startsWith('bankRuptcy-dutch') ||
        props.auctionsMy.sellingMethod.startsWith('nonperformingLoans-english') ||
        props.auctionsMy.sellingMethod.startsWith('nonperformingLoans-dutch')
    ){
        createZUBanks1(props, aucId)
    }
}

async function createZUBanksLR(props, aucId){
    let tmpRregistrationFee = [],
        tmpGuarantee = [],
        tmpSecurityDeposit = [],
        tmpImprovementCompensation = [],
        tmpOther = [],
        tmpAdvancePayment = [],
        tmpLease = [],
        tmpPayment = [],
        tmpPreparationPayment = []

    for(let i=0; i < props.bankAccountZU.length; i++){
        if(props.bankAccountZU[i].groupe === 'registrationFee'){
            tmpRregistrationFee.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'guarantee'){
            tmpGuarantee.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'securityDeposit'){
            tmpSecurityDeposit.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'improvementCompensation'){
            tmpImprovementCompensation.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'other'){
            tmpOther.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'advancePayment'){
            tmpAdvancePayment.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'lease'){
            tmpLease.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'payment'){
            tmpPayment.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'preparationPayment'){
            tmpPreparationPayment.push(props.bankAccountZU[i])
        }
    }
    if(tmpPayment.length > 0){
        let data = {}
        let tmp = []
        for(let i=0; i < tmpPayment.length; i++){
            tmp[i] = Number(tmpPayment[i].id)
        }
        data.id = tmp
        data.groupe = "payment"
        createZUBanksPOSTLR(props, data, aucId)
    }
    if(tmpPreparationPayment.length > 0){
        let data = {}
        let tmp = []
        for(let i=0; i < tmpPreparationPayment.length; i++){
            tmp[i] = Number(tmpPreparationPayment[i].id)
        }
        data.id = tmp
        data.groupe = "preparationPayment"
        createZUBanksPOSTLR(props, data, aucId)
    }

    if(tmpRregistrationFee.length > 0){
        let data = {}
        let tmp = []
        for(let i=0; i < tmpRregistrationFee.length; i++){
            tmp[i] = Number(tmpRregistrationFee[i].id)
        }
        data.id = tmp
        data.groupe = "registrationFee"
        createZUBanksPOSTLR(props, data, aucId)
    }
    if(tmpGuarantee.length > 0){
        let data = {}
        let tmp = []
        for(let i=0; i < tmpGuarantee.length; i++){
            tmp[i] = Number(tmpGuarantee[i].id)
        }
        data.id = tmp
        data.groupe = "guarantee"
        createZUBanksPOSTLR(props, data, aucId)
    }
    if(tmpSecurityDeposit.length > 0){
        let data = {}
        let tmp = []
        for(let i=0; i < tmpSecurityDeposit.length; i++){
            tmp[i] = Number(tmpSecurityDeposit[i].id)
        }
        data.id = tmp
        data.groupe = "securityDeposit"
        createZUBanksPOSTLR(props, data, aucId)
    }
    if(tmpImprovementCompensation.length > 0){
        let data = {}
        let tmp = []
        for(let i=0; i < tmpImprovementCompensation.length; i++){
            tmp[i] = Number(tmpImprovementCompensation[i].id)
        }
        data.id = tmp
        data.groupe = "improvementCompensation"
        createZUBanksPOSTLR(props, data, aucId)
    }
    if(tmpOther.length > 0){
        let data = {}
        let tmp = []
        for(let i=0; i < tmpOther.length; i++){
            tmp[i] = Number(tmpOther[i].id)
        }
        data.id = tmp
        data.groupe = "other"
        createZUBanksPOSTLR(props, data, aucId)
    }
    if(tmpAdvancePayment.length > 0){
        let data = {}

        for(let i=0; i < tmpAdvancePayment.length; i++){
            //tmp[i] = Number(tmpAdvancePayment[i].id)
            data.id = Number(tmpAdvancePayment[i].id)
            data.groupe = "advancePayment"
            if(tmpAdvancePayment[i].percent !== ''){
                data.percent = tmpAdvancePayment[i].percent
            }
            if(tmpAdvancePayment[i].holderType !== 'null'){
                data.holderType = tmpAdvancePayment[i].holderType
            }
            createZUBanksPOSTLR(props, data, aucId)
        }
    }
    if(tmpLease.length > 0){
        let data = {}

        for(let i=0; i < tmpLease.length; i++){
            //tmp[i] = Number(tmpLease[i].id)
            data.id = Number(tmpLease[i].id)
            data.groupe = "lease"
            if(tmpLease[i].percent !== ''){
                data.percent = tmpLease[i].percent
            }
            if(tmpLease[i].holderType !== 'null'){
                data.holderType = tmpLease[i].holderType
            }
            createZUBanksPOSTLR(props, data, aucId)
        }
    }
}

async function createZUBanks1(props, aucId){
    let tmpRregistrationFee = [],
        tmpGuarantee = [],
        tmpSecurityDeposit = [],
        tmpImprovementCompensation = [],
        tmpOther = [],
        tmpAdvancePayment = [],
        tmpLease = [],
        tmpPayment = [],
        tmpPreparationPayment = []

    for(let i=0; i < props.bankAccountZU.length; i++){
        if(props.bankAccountZU[i].groupe === 'registrationFee'){
            tmpRregistrationFee.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'guarantee'){
            tmpGuarantee.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'securityDeposit'){
            tmpSecurityDeposit.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'improvementCompensation'){
            tmpImprovementCompensation.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'other'){
            tmpOther.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'advancePayment'){
            tmpAdvancePayment.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'lease'){
            tmpLease.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'payment'){
            tmpPayment.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'preparationPayment'){
            tmpPreparationPayment.push(props.bankAccountZU[i])
        }
    }
    if(tmpPayment.length > 0){
        let data = {}

        for(let i=0; i < tmpPayment.length; i++){
            //tmp[i] = Number(tmpPayment[i].id)
            data.id = Number(tmpPayment[i].id)
            data.groupe = "payment"
            await createZUBanksPOST1(props, data, aucId)
        }
    }
    if(tmpPreparationPayment.length > 0){
        let data = {}

        for(let i=0; i < tmpPreparationPayment.length; i++){
            //tmp[i] = Number(tmpPreparationPayment[i].id)
            data.id = Number(tmpPreparationPayment[i].id)
            data.groupe = "preparationPayment"
            await createZUBanksPOST1(props, data, aucId)
        }
    }

    if(tmpRregistrationFee.length > 0){
        let data = {}
        for(let i=0; i < tmpRregistrationFee.length; i++){
            data.id = Number(tmpRregistrationFee[i].id)
            data.groupe = "registrationFee"
            await createZUBanksPOST1(props, data, aucId)
        }
    }
    if(tmpGuarantee.length > 0){
        let data = {}
        for(let i=0; i < tmpGuarantee.length; i++){
            data.id = Number(tmpGuarantee[i].id)
            data.groupe = "guarantee"
            await createZUBanksPOST1(props, data, aucId)
        }
    }
    if(tmpSecurityDeposit.length > 0){
        let data = {}
        for(let i=0; i < tmpSecurityDeposit.length; i++){
            data.id = Number(tmpSecurityDeposit[i].id)
            data.groupe = "securityDeposit"
            createZUBanksPOST1(props, data, aucId)
        }
    }
    if(tmpImprovementCompensation.length > 0){
        let data = {}
        for(let i=0; i < tmpImprovementCompensation.length; i++){
            data.id = Number(tmpImprovementCompensation[i].id)
            data.groupe = "improvementCompensation"
            await createZUBanksPOST1(props, data, aucId)
        }
    }
    if(tmpOther.length > 0){
        let data = {}
        for(let i=0; i < tmpOther.length; i++){
            data.id = Number(tmpOther[i].id)
            data.groupe = "other"
            await createZUBanksPOST1(props, data, aucId)
        }
    }
    if(tmpAdvancePayment.length > 0){
        let data = {}
        for(let i=0; i < tmpAdvancePayment.length; i++){
            data.id = Number(tmpAdvancePayment[i].id)
            data.groupe = "advancePayment"
            if(tmpAdvancePayment[i].percent !== ''){
                data.percent = tmpAdvancePayment[i].percent
            }
            if(tmpAdvancePayment[i].holderType !== 'null'){
                data.holderType = tmpAdvancePayment[i].holderType
            }
            await createZUBanksPOST1(props, data, aucId)
        }
    }
    if(tmpLease.length > 0){
        let data = {}

        let tmpId = null
        for(let i=0; i < tmpLease.length; i++){
            data.id = Number(tmpLease[i].id)
            data.groupe = "lease"
            if(tmpLease[i].percent !== ''){
                data.percent = tmpLease[i].percent
            }
            if(tmpLease[i].holderType !== 'null'){
                data.holderType = tmpLease[i].holderType
            }
            await createZUBanksPOST1(props, data, aucId, i, tmpId)
        }
    }
    await clearBanks(props)
}

async function createZUBanksPOST1(props, data, aucId){
    let body = {}
    for(let i = 0; i < props.bankAccount.length; i++){
        if(props.bankAccount[i].id === Number(data.id)){
            body.bankAccounts = [
                {
                    id: props.bankAccount[i].id,
                    bankName: props.bankAccount[i].bankName,
                    currency: props.bankAccount[i].currency,
                    accountIdentifications: [
                        {
                            id: props.bankAccount[i].accountIdentifications[0].id,
                            description: props.bankAccount[i].accountIdentifications[0].description,
                            identifier: props.bankAccount[i].accountIdentifications[0].identifier,
                            scheme: props.bankAccount[i].accountIdentifications[0].scheme
                        }
                    ],
                    accountHolder: props.bankAccount[i].accountHolder
                }
            ]
        }
    }

    if(
        data.groupe === 'advancePayment' ||
        data.groupe === 'lease'
    ){
        if(data.holderType !== 'null') body.holderType = data.holderType
        if(data.percent !== '') body.percent = data.percent
    }
    let endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/auction/${aucId}/bank_account_groups/${data.groupe}`
    const response = await fetch(endPoint, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: "Помилка при створенні Тип переліку, до якого віднесено об'єкт", message: JSON.stringify(json)})
            props.setUniversalError(tmp)
        }
    }
    return null
}

async function createZUBanksPOSTLR(props, data, aucId){
    let body = {}
    body.bankAccountIds = data.id
    if(
        data.groupe === 'advancePayment' ||
        data.groupe === 'lease'
    ){
        if(data.holderType !== 'null') body.holderType = data.holderType
        if(data.percent !== '') body.percent = data.percent
    }
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/auction/${aucId}/bank_account_groups/${data.groupe}`
    const response = await fetch(endPoint, {
        method: "POST",
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: "Помилка при створенні Тип переліку, до якого віднесено об'єкт", message: JSON.stringify(json)})
            props.setUniversalError(tmp)
        }else{
            await addArrayBankAccountsClear(props)
            await addBankAccountZUtimestamp(props)
        }
    }
}


///////////////////////////////////////////////
///////////////////////////////////////////////


function dutchData(props) {
    switch (true) {
        case props.auctionsMy.sellingMethod.startsWith("railwayCargo-dutch"):
        case props.auctionsMy.sellingMethod.startsWith("subsoil-dutch"):
        case props.auctionsMy.sellingMethod.startsWith("dgf-dutch"):
        case props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-dutch"):
            return true
        default:
            return false
    }
}

async function cloneAuc(props){
    let tmpCarryType = null;
    if(props.auctionsMy.carryType !== null) {tmpCarryType = props.auctionsMy.carryType}
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/auction`;

    let minNumberOfQualifiedBids = returnDataRailway(props)
    if(minNumberOfQualifiedBids === 'null') minNumberOfQualifiedBids = null
    let tmpBody = {}
    if (props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish")) {
        if(props.auctionsMy.currentTenantGuaranteeFee.amount !== ''){
            tmpBody.currentTenantGuaranteeFee = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.currentTenantGuaranteeFee.amount)
            }
        }
    }
    tmpBody.documentationValue = props.auctionsMy.documentationValue
    tmpBody.geologicDataValue = props.auctionsMy.geologicDataValue
    tmpBody.leaseDuration = props.auctionsMy.leaseDuration
    if(tmpCarryType !== null){
        let texttmpCarryType = typeof tmpCarryType
        if(texttmpCarryType === 'string'){
            for(let tmI = 0; tmI < props.carryType.length; tmI++){
                if(tmpCarryType === props.carryType[tmI].name){
                    tmpBody.carryType = tmpCarryType
                }
            }
        }else if(texttmpCarryType === 'object'){
            tmpBody.carryType = tmpCarryType.name
        }
    }
    tmpBody.title = props.auctionsMy.title
    tmpBody.description = props.auctionsMy.description
    if(
        !props.auctionsMy.sellingMethod.startsWith("subsoil-english") &&
        props.auctionsMy.sellingMethod.startsWith("subsoil-dutch")
    ){
        tmpBody.bankAccountIds = createArrBanks(props, 1, props.auctionsMy.id)
    }
    tmpBody.sellingMethod = props.auctionsMy.sellingMethod
    tmpBody.tenderAttempts = props.auctionsMy.tenderAttempts
    if(props.auctionsMy.accessDetails !== null && props.auctionsMy.accessDetails !== ''){
        tmpBody.accessDetails = props.auctionsMy.accessDetails
    }
    if (
        props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-english") ||
        props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-dutch") ||
        props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish")
    ) {
        tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
    }else{
        tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
        if(props.auctionsMy.xDocumentRequirements !== null && props.auctionsMy.xDocumentRequirements !== ''){
            tmpBody.xDocumentRequirements = props.auctionsMy.xDocumentRequirements
        }
    }
    if(props.auctionsMy.xAdditionalInformation !== null && props.auctionsMy.xAdditionalInformation !== ''){
        tmpBody.xAdditionalInformation = props.auctionsMy.xAdditionalInformation
    }
    if (
        props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-english") ||
        props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish")
    ) {
        if(props.auctionsZUAttemp.tenderAttempts === 1 && props.auctionsMy.tenderAttempts === '2'){
            //let tmpZU = props.auctionsZUAttemp.value.amount / 2
            let tmpZU = props.auctionsZUAttemp.value.amount
            //let tmpGarantyZU = (tmpZU / 100) * 5
            let tmpGarantyZU = props.auctionsZUAttemp.guarantee.amount
            //let tmpMinStepZU = (tmpZU / 100) * 1
            let tmpMinStepZU = props.auctionsZUAttemp.minimalStep.amount
            tmpBody.value = {
                currency: props.auctionsMy.value.currency,
                amount: Number(tmpZU),
                valueAddedTaxIncluded: props.auctionsMy.value.valueAddedTaxIncluded
            }
            tmpBody.guarantee = {
                currency: props.auctionsMy.guarantee.currency,
                amount: Number(tmpGarantyZU),
            }
            tmpBody.minimalStep = {
                currency: props.auctionsMy.minimalStep.currency,
                amount: Number(tmpMinStepZU),
            }
        }else{
            tmpBody.value = {
                currency: props.auctionsMy.value.currency,
                amount: Number(props.auctionsMy.value.amount),
                valueAddedTaxIncluded: props.auctionsMy.value.valueAddedTaxIncluded
            }
            tmpBody.guarantee = {
                currency: props.auctionsMy.guarantee.currency,
                amount: Number(props.auctionsMy.guarantee.amount),
            }
            tmpBody.minimalStep = {
                currency: props.auctionsMy.minimalStep.currency,
                amount: Number(props.auctionsMy.minimalStep.amount),
            }
        }
    }else{
        tmpBody.value = {
            currency: props.auctionsMy.value.currency,
            amount: Number(props.auctionsMy.value.amount),
            valueAddedTaxIncluded: props.auctionsMy.value.valueAddedTaxIncluded
        }
        tmpBody.guarantee = {
            currency: props.auctionsMy.guarantee.currency,
            amount: Number(props.auctionsMy.guarantee.amount),
        }
        tmpBody.minimalStep = {
            currency: props.auctionsMy.minimalStep.currency,
            amount: Number(props.auctionsMy.minimalStep.amount),
        }
    }
    tmpBody.minNumberOfQualifiedBids = minNumberOfQualifiedBids
    tmpBody.startDate = props.auctionsMy.startDate
    tmpBody.documents = props.auctionsMy.documents
    if(Number(props.auctionsMy.tenderAttempts) !== 1){
        tmpBody.previousAuctionId = props.discount.previousAuctionId
    }

    switch(true){
        case props.auctionsMy.sellingMethod.startsWith("dgf-english"):
        case props.auctionsMy.sellingMethod.startsWith("dgf-dutch"):
        case "dgf-dutch-fast":
            tmpBody.minNumberOfQualifiedBids = props.auctionsMy.minNumberOfQualifiedBids
            tmpBody.virtualDataRoom = props.auctionsMy.virtualDataRoom
            tmpBody.eligibilityCriteria = props.auctionsMy.eligibilityCriteria
            tmpBody.decision = {
                decisionId: props.auctionsMy.decision.decisionId,
                decisionDate: props.auctionsMy.decision.decisionDate
            }
            tmpBody.x_dgfPlatformLegalDetails = props.auctionsMy.x_dgfPlatformLegalDetails
            break;
        case props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-english"):
        case props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-dutch"):
        case props.auctionsMy.sellingMethod.startsWith( "legitimatePropertyLease-priorityEnglish"):
            if(Number(props.auctionsMy.minNumberOfQualifiedBids) === 1 || Number(props.auctionsMy.minNumberOfQualifiedBids) === 2){
                tmpBody.minNumberOfQualifiedBids = Number(props.auctionsMy.minNumberOfQualifiedBids)
            }else{
                tmpBody.minNumberOfQualifiedBids = 1
            }
            tmpBody.calcOnBookValue = props.auctionsMy.calcOnBookValue
            tmpBody.valueAddedTaxCharged = props.auctionsMy.valueAddedTaxCharged
            tmpBody.registryId = props.auctionsMy.registryId
            if(props.auctionsMy.registrationFee.valueAddedTaxIncluded === true || props.auctionsMy.registrationFee.valueAddedTaxIncluded === 'true'){
                tmpBody.registrationFee = {
                    currency: 'UAH',
                    amount: Number(props.auctionsMy.registrationFee.amount),
                    valueAddedTaxIncluded: true
                }
            }else if(props.auctionsMy.registrationFee.valueAddedTaxIncluded === false || props.auctionsMy.registrationFee.valueAddedTaxIncluded === 'false'){
                tmpBody.registrationFee = {
                    currency: 'UAH',
                    amount: Number(props.auctionsMy.registrationFee.amount),
                    valueAddedTaxIncluded: false
                }
            }else{
                tmpBody.registrationFee = {
                    currency: 'UAH',
                    amount: Number(props.auctionsMy.registrationFee.amount),
                }
            }
            tmpBody.valuePeriod = props.auctionsMy.valuePeriod
            break;
        default:
            break;
    }

    const response = await fetch(endPoint, {
        method: "POST",

        //timberEnglish
        body: JSON.stringify(tmpBody),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
        props.changeAuctionsSwitchWindow(0)
        props.changeCreateAuctionTab(0);
        getData(props)
    }else{
        //props.setPopUpAuctionMyNull()
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: 'Помилка при створенні копії аукціону', message: JSON.stringify(json)})
            props.setUniversalError(tmp)
            props.changeAuctionsSwitchWindow(0)
            props.changeCreateAuctionTab(0);
            getData(props)
        }else{
            if (
                json.sellingMethod.startsWith("legitimatePropertyLease-english") ||
                json.sellingMethod.startsWith("legitimatePropertyLease-dutch") ||
                json.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish")
            ) {
                createAuctionLeaseRules(props, json.id)
                let data = {}
                if(props.auctionsZUAttemp.bankAccountsGroups !== null){
                    if(props.auctionsZUAttemp.bankAccountsGroups.length !== null){
                        for(let i = 0; i < props.auctionsZUAttemp.bankAccountsGroups.length; i++){
                            if(props.auctionsZUAttemp.bankAccountsGroups[i].type === "registrationFeeAccounts"){
                                data.id = props.auctionsZUAttemp.bankAccountsGroups[i].id
                                data.group = props.auctionsZUAttemp.bankAccountsGroups[i].type
                                if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsForeign.length > 0){
                                    data.type = 'bankAccountsForeign'
                                }else if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsUa.length > 0){
                                    data.type = 'bankAccountsUa'
                                }
                                data.gropType = 'default'
                                await createZUBanksPOST(props, data, json.id)
                            }
                            if(props.auctionsZUAttemp.bankAccountsGroups[i].type === "guaranteeAccounts"){
                                data.id = props.auctionsZUAttemp.bankAccountsGroups[i].id
                                data.group = props.auctionsZUAttemp.bankAccountsGroups[i].type
                                if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsForeign.length > 0){
                                    data.type = 'bankAccountsForeign'
                                }else if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsUa.length > 0){
                                    data.type = 'bankAccountsUa'
                                }
                                data.gropType = 'default'
                                await createZUBanksPOST(props, data, json.id)
                            }
                            if(props.auctionsZUAttemp.bankAccountsGroups[i].type === "advancePaymentAccounts"){
                                data.id = props.auctionsZUAttemp.bankAccountsGroups[i].id
                                data.group = props.auctionsZUAttemp.bankAccountsGroups[i].type
                                if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsForeign.length > 0){
                                    data.type = 'bankAccountsForeign'
                                }else if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsUa.length > 0){
                                    data.type = 'bankAccountsUa'
                                }
                                data.gropType = 'default'
                                await createZUBanksPOST(props, data, json.id)
                            }
                            if(props.auctionsZUAttemp.bankAccountsGroups[i].type === "securityDepositAccounts"){
                                data.id = props.auctionsZUAttemp.bankAccountsGroups[i].id
                                data.group = props.auctionsZUAttemp.bankAccountsGroups[i].type
                                if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsForeign.length > 0){
                                    data.type = 'bankAccountsForeign'
                                }else if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsUa.length > 0){
                                    data.type = 'bankAccountsUa'
                                }
                                data.gropType = 'default'
                                await createZUBanksPOST(props, data, json.id)
                            }
                            if(props.auctionsZUAttemp.bankAccountsGroups[i].type === "improvementsCompensationAccounts"){
                                data.id = props.auctionsZUAttemp.bankAccountsGroups[i].id
                                data.group = props.auctionsZUAttemp.bankAccountsGroups[i].type
                                if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsForeign.length > 0){
                                    data.type = 'bankAccountsForeign'
                                }else if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsUa.length > 0){
                                    data.type = 'bankAccountsUa'
                                }
                                data.gropType = 'default'
                                await createZUBanksPOST(props, data, json.id)
                            }
                            if(props.auctionsZUAttemp.bankAccountsGroups[i].type === "otherAccounts"){
                                data.id = props.auctionsZUAttemp.bankAccountsGroups[i].id
                                data.group = props.auctionsZUAttemp.bankAccountsGroups[i].type
                                if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsForeign.length > 0){
                                    data.type = 'bankAccountsForeign'
                                }else if(props.auctionsZUAttemp.bankAccountsGroups[i].bankAccountsUa.length > 0){
                                    data.type = 'bankAccountsUa'
                                }
                                data.gropType = 'default'
                                await createZUBanksPOST(props, data, json.id)
                            }
                        }
                    }
                }
                if(props.auctionsMy.items !== null){
                    if(props.auctionsMy.items.length > 0){
                        for(let i = 0; i < props.auctionsMy.items.length; i++){
                            await createItemZU(props, props.auctionsMy.items[i], json.id)
                        }
                    }
                }
            }else{
                if(props.auctionsMy.items !== null){
                    if(props.auctionsMy.items.length > 0){
                        for(let i = 0; i < props.auctionsMy.items.length; i++){
                            await createItemEnergy(props, props.auctionsMy.items[i], json.id)
                        }
                    }
                }
            }
            //if(props.discount.discountOnOff === true){
            await createDiscountForAuction(props, json.id)
            //}
            if(dutchData(props) !== false){
                let dutchStep = {
                    dutchStepQuantity: props.auctionsMy.dutchStep.dutchStepQuantity,
                    dutchStepPercent: props.auctionsMy.dutchStep.dutchStepPercent,
                    dutchStepValue: {
                        currency: 'UAH',
                        amount: props.auctionsMy.dutchStep.dutchStepValue.amount,
                        //valueAddedTaxIncluded: null,
                    },
                }
                const endPoint3 = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${json.id}/dutch_step`
                const response3 = await fetch(endPoint3, {
                    method: "POST",
                    body: JSON.stringify(dutchStep),
                    headers: getDefaultHeaders(props)
                }).catch(console.error)
                if(response3 === undefined || response3 === 'undefined'){
                }else{
                    const json3 = await response3.json()
                    if(json3.hasOwnProperty('message') === true){
                        let tmp = JSON.stringify({title: 'Помилка при створенні аукціону', message: JSON.stringify(json3)})
                        props.setUniversalError(tmp)
                        props.changeAuctionsSwitchWindow(0)
                        props.changeCreateAuctionTab(0);
                        getData(props)
                    }else{
                        let tmpAucData = json
                        tmpAucData.dutchStep = json3
                        props.setPopUpAuctionCreate(tmpAucData)
                        createDiscountForAuction(props, json.id)
                        props.changeDiscountPreviousAuctionCurrency('null')
                        props.changeDiscountPreviousAuctionAmount('')
                        props.changeDiscountPercent('')
                        props.changeDiscountPreviousAuctionId('')
                        props.discountAuc(false)
                    }
                }
            }else{
                props.changeDiscountPreviousAuctionCurrency('null')
                props.changeDiscountPreviousAuctionAmount('')
                props.changeDiscountPercent('')
                props.changeDiscountPreviousAuctionId('')
                props.discountAuc(false)
                props.changeAuctionsSwitchWindow(0)
                props.changeCreateAuctionTab(0);
                getData(props)
            }
        }
    }

    props.changeCreateAuctionLotIdentifier('')
    props.changeCreateAuctionTitle('')
    props.changeCreateAuctionDescription('')
    props.changeCreateAuctionTenderAttempts('')
    props.changeCreateAuctionAccessDetails('')
    props.changeCreateAuctionXDocumentRequirements('')
    props.changeCreateAuctionXAdditionalInformation('')
    props.changeCreateAuctionType('null')
    props.changeCreateAuctionValueCurrency('null')
    props.changeCreateAuctionValueAmount('')
    props.changeCreateAuctionGuaranteeCurrency('null')
    props.changeCreateAuctionGuaranteeAmount('')
    props.changeCreateAuctionMinimalStepCurrency('null')
    props.changeCreateAuctionMinimalStepAmount('')
    props.changeCreateAuctionDateStart('')
    props.setPopBankAccountId('null')
    props.setPopBankAccountIdArr(null)
    props.changeDiscountPreviousAuctionCurrency('null')
    props.changeDiscountPreviousAuctionAmount('')
    props.changeDiscountPercent('')
    props.changeDiscountPreviousAuctionId('')
    props.discountAuc(false)
    props.setBankAccountSave([])
    props.setBankAccountAdd([])
    props.setBankAccountDelete([])
    props.changeCreateAuctionMinNumberOfQualifiedBids('2')
    props.changeCreateAuctionDgfVirtualDataRoom('')
    props.changeCreateAuctionDgfEligibilityCriteria('null')
    props.changeCreateAuctionDgfX_dgfPlatformLegalDetails('')
    props.changeCreateAuctionDgfDecisionId('')
    props.changeCreateAuctionDgfDecisionDate('')

    await props.changeAuctionsSwitchWindow(0)
    await props.changeCreateAuctionTab(0);
    await getData(props)

}

async function getData(props){
    let data = {
        domen: process.env.REACT_APP_END_POINT_BD,
        version: 'v1',
        local: props.langFlag,
        params: '?offset=0'
    }
    let header = {
        'Authorization': props.token.access_token,
        'Content-Type': 'application/json'
    }
    //props.auctionsBidsGetMy(data, header)
    //props.bankAccountGet(data, header)
    props.auctionsGetMy(data, header)
    /*await props.workMyPageCurrentAuction(0)
    if(props.auctionsMy !== null){
        if(props.auctionsMy.length === 10) {
            await props.workMyPageNextAuction(1)
        }else{
            await props.workMyPageNextAuction(null)
        }
    }*/
}

function returnDataRailway(props){
    switch(true){
        case props.auctionsMy.sellingMethod.startsWith("railwayCargo-english"):
        case props.auctionsMy.sellingMethod.startsWith("railwayCargo-dutch"):
        case props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-english"):
        case props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-dutch"):
        case props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish"):
            return props.auctionsMy.minNumberOfQualifiedBids
        default:
            return 1
    }
}

///////////////////////////////////////////////////////
//КЛОНИРОВАНИЕ ИТЕМОВ
//////////////////////////////////////////////////////
async function createItemZU(props, item, auctionId){
    if(item.itemType === 'otherProperty'){
        createItemZUOtherPropertyItem(props, item, auctionId)
    }else if(item.itemType === 'jointPropertyComplex'){
        createItemZUJointPropertyComplexItem(props, item, auctionId)
    }else if(item.itemType === 'vehicle'){
        createItemZUVehicleItem(props, item, auctionId)
    }else if(item.itemType === 'realEstate'){
        createItemZURealEstateItem(props, item, auctionId)
    }
}
async function createItemZUOtherPropertyItem(props, item, auctionId){
    if(props.userProfiles !== null){
        if(props.userProfiles.organization.address.id !== null){
            let body = {}
            body.title = item.title
            body.description = item.description
            body.classificationId = Number(item.classification.id)
            body.additionalClassificationIds = item.additionalClassification
            body.addressId = Number(item.address.id)
            if(item.location !== null){
                body.location = {
                    latitude: Number(item.location.latitude),
                    longitude: Number(item.location.longitude),
                    //elevation: item.location.elevation
                }
            }
            body.itemType = item.itemType
            body.quantity = item.quantity
            body.unitCode = item.unit.code
            const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item`;
            const response = await fetch(endPoint, {
                method: "POST",
                body: JSON.stringify(body),
                headers: getDefaultHeaders(props)
            }).catch(console.error)
            if(response === undefined || response === 'undefined'){
            }else{
                const json1 = await response.json()
                if(json1.hasOwnProperty('message') === true){
                    props.changeLoader(false)
                }else{
                    if(item.registrationDetails !== null){
                        await createRegDetal(props, auctionId, json1.id, item)
                    }
                }
            }
        }
    }
}

async function createItemZUVehicleItem(props, item, auctionId){
    if(props.userProfiles !== null){
        if(props.userProfiles.organization.address.id !== null){
            let body = {}
            body.title = item.title
            body.description = item.description
            body.classificationId = Number(item.classification.id)
            body.additionalClassificationIds = item.additionalClassification
            body.addressId = Number(item.address.id)
            if(item.location !== null){
                body.location = {
                    latitude: Number(item.location.latitude),
                    longitude: Number(item.location.longitude),
                    //elevation: item.location.elevation
                }
            }
            body.itemType = item.itemType
            body.quantity = item.quantity
            body.unitCode = item.unit.code
            const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item`;
            const response = await fetch(endPoint, {
                method: "POST",
                body: JSON.stringify(body),
                headers: getDefaultHeaders(props)
            }).catch(console.error)
            if(response === undefined || response === 'undefined'){
            }else{
                const json = await response.json()
                if(item.registrationDetails !== null){
                    await createRegDetal(props, auctionId, json.id, item)
                }
                if(item.vehicleProps !== null){
                    await saveItemZuVehicleProps(props, item.vehicleProps, auctionId, json.id)
                }
            }
        }
    }
}
async function saveItemZuVehicleProps(props, item, auctionId, itemId){
    let body
    body = {
        brand: item.brand,
        model: item.model,
        productionYear: item.productionYear,
        engineCapacity: item.engineCapacity,
        fuelType: item.fuelType,
        transmission: item.transmission,
        color: item.color,
        kilometrage: item.kilometrage,
        identificationNumber: item.identificationNumber,
        configuration: item.configuration,
        condition: item.condition,
        damagedDescription: item.damagedDescription,
        damagePresence: item.damagePresence,
    }
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item/${itemId}/property_props/VehicleProps`;
    await fetch(endPoint, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error);

}

async function createItemZURealEstateItem(props, item, auctionId){
    if(props.userProfiles !== null){
        if(props.userProfiles.organization.address.id !== null){
            let body = {}
            body.title = item.title
            body.description = item.description
            body.classificationId = Number(item.classification.id)
            body.additionalClassificationIds = item.additionalClassification
            body.addressId = Number(item.address.id)
            if(item.location !== null){
                body.location = {
                    latitude: Number(item.location.latitude),
                    longitude: Number(item.location.longitude),
                    //elevation: item.location.elevation
                }
            }
            body.itemType = item.itemType
            body.unitCode = item.unit.code
            const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item`;
            const response = await fetch(endPoint, {
                method: "POST",
                body: JSON.stringify(body),
                headers: getDefaultHeaders(props)
            }).catch(console.error)
            if(response === undefined || response === 'undefined'){
            }else{
                const json = await response.json()
                if(item.registrationDetails !== null){
                    await createRegDetal(props, auctionId, json.id, item)
                }
                if(item.realEstateProps !== null){
                    await saveItemZuReProps(props, item.realEstateProps, auctionId, json.id)
                }
            }
        }
    }
}
async function saveItemZuReProps(props, item, auctionId, itemId){
    let body
    body = {
        totalBuildingArea: item.totalBuildingArea,
        totalObjectArea: item.totalObjectArea,
        usableArea: item.usableArea,
        constructionYear: item.constructionYear,
        constructionTechnology: item.constructionTechnology,
        livingArea: item.livingArea,
        kitchenArea: item.kitchenArea,
        landArea: item.landArea,
        locationInBuilding: item.locationInBuilding,
        floors: item.floors,
        generalCondition: item.generalCondition,
        serviceElectricity: item.serviceElectricity,
        powerSupplyCapacity: item.powerSupplyCapacity,
        powerSupplyClass: item.powerSupplyClass,
        serviceWater: item.serviceWater,
        serviceSewerage: item.serviceSewerage,
        serviceGas: item.serviceGas,
        serviceCentralHeating: item.serviceCentralHeating,
        serviceAutonomousHeating: item.serviceAutonomousHeating,
        serviceHeatingCounter: item.serviceHeatingCounter,
        serviceVentilation: item.serviceVentilation,
        serviceAirConditioning: item.serviceAirConditioning,
        servicePhone: item.servicePhone,
        serviceTV: item.serviceTV,
        serviceInternet: item.serviceInternet,
        serviceElevator: item.serviceElevator,
        serviceSecurityAlarm: item.serviceSecurityAlarm,
        serviceFireAlarm: item.serviceFireAlarm,
        servicesDescription: item.servicesDescription,
        servicesAccounting: item.servicesAccounting,
        landTax: item.landTax,
    }
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item/${itemId}/property_props/RealEstateProps`;
    await fetch(endPoint, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error);

}

async function createItemZUJointPropertyComplexItem(props, item, auctionId){
    if(props.userProfiles !== null){
        if(props.userProfiles.organization.address.id !== null){
            let body = {}
            body.title = item.title
            body.description = item.description
            body.classificationId = Number(item.classification.id)
            body.additionalClassificationIds = item.additionalClassification
            body.addressId = Number(item.address.id)
            if(item.location !== null){
                body.location = {
                    latitude: Number(item.location.latitude),
                    longitude: Number(item.location.longitude),
                    //elevation: item.location.elevation
                }
            }
            body.itemType = item.itemType
            body.quantity = item.quantity
            body.unitCode = item.unit.code
            const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item`;
            const response = await fetch(endPoint, {
                method: "POST",
                body: JSON.stringify(body),
                headers: getDefaultHeaders(props)
            }).catch(console.error)
            if(response === undefined || response === 'undefined'){
            }else{
                const json = await response.json()
                if(json.hasOwnProperty('message') === true){
                    let tmp = JSON.stringify({title: 'Помилка', message: JSON.stringify(json)})
                    props.setUniversalError(tmp)
                }
                if(item.registrationDetails !== null){
                    await createRegDetal(props, auctionId, json.id, item)
                }
                if(item.jointPropertyComplexProps !== null){
                    await saveItemZuJointPropertyComplexProps(props, item.jointPropertyComplexProps, auctionId, json.id)
                }
            }
        }
    }
}
async function saveItemZuJointPropertyComplexProps(props, item, auctionId, itemId){
    let body
    body = {
        quantityAndNomenclature: item.quantityAndNomenclature,
        workplacesQuantity: item.workplacesQuantity,
        buildingsInformation: item.buildingsInformation,
        landPlotInformation: item.landPlotInformation,
        mainObligations: item.mainObligations
    }
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item/${itemId}/property_props/JointPropertyComplexProps`;
    const response = await fetch(endPoint, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: 'Помилка', message: JSON.stringify(json)})
	        props.setUniversalError(tmp)
        }
        if(item.landProps !== null){
            await saveItemZuJointPropertyComplexPropsLand(props, item.landProps, auctionId, itemId)
        }
    }
}
async function saveItemZuJointPropertyComplexPropsLand(props, item, auctionId, itemId){
    let body
    body = {
        landArea: item.landArea,
        cadastralNumber: item.cadastralNumber,
        ownershipType: item.ownershipType,
        encumbrances: item.encumbrances,
        jointOwnership: item.jointOwnership,
        utilitiesAvailability: item.utilitiesAvailability,
        landIntendedUse: item.landIntendedUse
    }
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item/${itemId}/property_props/JointPropertyComplexProps/land_props`;
    await fetch(endPoint, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
}

async function createRegDetal(props, auctionId, jsonId, item){
    if(props.userProfiles !== null){
        if(props.userProfiles.organization.address.id !== null){
            const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item/${jsonId}/registration_details`;
            await fetch(endPoint, {
                method: "POST",
                body: JSON.stringify({
                    registrationStatus: item.registrationDetails.registrationStatus,
                    registrationID: item.registrationDetails.registrationID,
                    registrationDate: item.registrationDetails.registrationDate,
                }),
                headers: getDefaultHeaders(props)
            }).catch(console.error);

        }
    }
}
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
async function createItemEnergy(props, item, auctionId){
    if(props.userProfiles !== null){
        if(props.userProfiles.organization.address.id !== null){
            const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item`;
            const arrAddClass = [];
            let body = null;
            switch(props.auctionsMy.sellingMethod){
                case "timber-english":
                case "timber-english-fast":
                case "timber-english-fast-manual":
                case "timber-english-initial-auction":
                case "timber-english-initial-qualification":
                case "timber-english-initial-qualification-fast":
                    if(item.additionalClassifications !== null){
                        if(item.additionalClassifications.length > 0){
                            for(let tt = 0; tt < item.additionalClassifications.length; tt++){
                                arrAddClass[tt] = {scheme: item.additionalClassifications[tt].scheme, classificationId: item.additionalClassifications[tt].classificationId}
                            }
                        }
                    }
                    body = JSON.stringify({
                        classificationId: Number(item.classification.id),
                        additionalClassifications: arrAddClass,
                        addressId: props.userProfiles.organization.address.id,
                        description: item.description,
                        unitCode: item.unit.code,
                        quantity: `${item.quantity}`,
                        unitValue: {
                            currency: 'UAH',                                 //+            //Валюта
                            amount: item.unitValue.amount,      //+                               //Цена
                        },
                    })
                    break;
                case "renewables":
                case "renewables-fast":
                case "renewables-fast-manual":
                case "renewables-initial-auction":
                case "renewables-initial-qualification":
                case "renewables-initial-qualification-fast":
                case "subsoil-english":
                case "subsoil-english-fast":
                case "subsoil-english-fast-manual":
                case "subsoil-english-initial-auction":
                case "subsoil-english-initial-qualification":
                case "subsoil-dutch":
                case "subsoil-dutch-fast":
                case "subsoil-dutch-fast-manual":
                case "subsoil-dutch-initial-auction":
                case "subsoil-dutch-initial-qualification":
                case "subsoil-dutch-initial-auction-manual":
                case "subsoil-english-fast-auction-manual-qualification":
                case "railwayCargo-english":
                case "railwayCargo-english-fast":
                case "railwayCargo-english-fast-manual":
                case "railwayCargo-english-initial-auction":
                case "railwayCargo-english-initial-qualification":
                case "railwayCargo-dutch":
                case "railwayCargo-dutch-fast":
                case "railwayCargo-dutch-fast-manual":
                case "railwayCargo-dutch-initial-auction":
                case "railwayCargo-dutch-initial-qualification":
                case "railwayCargo-dutch-fast-auction-manual-qualification":
                case "railwayCargo-dutch-initial-auction-manual":
                case "dgf-english":
                case "dgf-english-fast":
                case "dgf-english-fast-manual":
                case "dgf-english-fast-auction-manual-qualification":
                case "dgf-english-initial-auction":
                case "dgf-english-initial-auction-manual":
                case "dgf-english-initial-qualification":
                case "dgf-dutch":
                case "dgf-dutch-fast":
                case "dgf-dutch-fast-manual":
                case "dgf-dutch-fast-auction-manual-qualification":
                case "dgf-dutch-initial-auction":
                case "dgf-dutch-initial-qualification":
                case "dgf-dutch-initial-auction-manual":
                case "legitimatePropertyLease-english":
                case "legitimatePropertyLease-english-fast":
                case "legitimatePropertyLease-english-fast-manual":
                case "legitimatePropertyLease-english-fast-auction-manual-qualification":
                case "legitimatePropertyLease-english-initial-auction":
                case "legitimatePropertyLease-english-initial-auction-manual":
                case "legitimatePropertyLease-english-initial-qualification":
                case "legitimatePropertyLease-english-initial-qualification-prod":
                case "legitimatePropertyLease-dutch":
                case "legitimatePropertyLease-dutch-fast":
                case "legitimatePropertyLease-dutch-fast-manual":
                case "legitimatePropertyLease-dutch-fast-auction-manual-qualification":
                case "legitimatePropertyLease-dutch-initial-auction":
                case "legitimatePropertyLease-dutch-initial-auction-manual":
                case "legitimatePropertyLease-dutch-initial-qualification-prod":
                case "legitimatePropertyLease-priorityEnglish":
                case "legitimatePropertyLease-priorityEnglish-fast":
                case "legitimatePropertyLease-priorityEnglish-fast-manual":
                case "legitimatePropertyLease-priorityEnglish-fast-auction-manual-qualification":
                case "legitimatePropertyLease-priorityEnglish-initial-auction":
                case "legitimatePropertyLease-priorityEnglish-initial-auction-manual":
                case "legitimatePropertyLease-priorityEnglish-initial-qualification":
                case "legitimatePropertyLease-priorityEnglish-initial-qualification-prod":
                    if(item.additionalClassifications !== null){
                        if(item.additionalClassifications.length > 0){
                            for(let tt = 0; tt < item.additionalClassifications.length; tt++){
                                arrAddClass[tt] = Number(item.additionalClassifications[tt].id)
                            }
                        }
                    }

                    let tmpRequestLifeTimeStartDate = null
                    if(item.hasOwnProperty('requestLifeTime') === true){
                        if(item.requestLifeTime !== null){
                            if(item.requestLifeTime.hasOwnProperty('startDate') === true){
                                if(item.requestLifeTime.startDate !== null){
                                    tmpRequestLifeTimeStartDate = item.requestLifeTime.startDate
                                }
                            }
                        }
                    }
                    let tmpRequestLifeTimeEndDate = null
                    if(item.hasOwnProperty('requestLifeTime') === true){
                        if(item.requestLifeTime !== null){
                            if(item.requestLifeTime.hasOwnProperty('endDate') === true){
                                if(item.requestLifeTime.endDate !== null){
                                    tmpRequestLifeTimeEndDate = item.requestLifeTime.endDate
                                }
                            }
                        }
                    }
                    let tmpLoadLifeTimeStartDate = null
                    if(item.hasOwnProperty('loadLifeTime') === true){
                        if(item.loadLifeTime !== null){
                            if(item.loadLifeTime.hasOwnProperty('startDate') === true){
                                if(item.loadLifeTime.startDate !== null){
                                    tmpLoadLifeTimeStartDate = item.loadLifeTime.startDate
                                }
                            }
                        }
                    }
                    let tmpLoadLifeTimeEndDate = null
                    if(item.hasOwnProperty('loadLifeTime') === true){
                        if(item.loadLifeTime !== null){
                            if(item.loadLifeTime.hasOwnProperty('endDate') === true){
                                if(item.loadLifeTime.endDate !== null){
                                    tmpLoadLifeTimeEndDate = item.loadLifeTime.endDate
                                }
                            }
                        }
                    }


                    body = JSON.stringify({
                        classificationId: Number(item.classification.id),
                        additionalClassificationIds: arrAddClass,
                        addressId: props.userProfiles.organization.address.id,
                        description: item.description,
                        unitCode: item.unit.code,
                        quantity: `${item.quantity}`,
                        requestLifeTime: {
                            startDate: tmpRequestLifeTimeStartDate,
                            endDate: tmpRequestLifeTimeEndDate
                        },
                        loadLifeTime: {
                            startDate: tmpLoadLifeTimeStartDate,
                            endDate: tmpLoadLifeTimeEndDate
                        },
                        routeQuantity: item.routeQuantity,
                        routesAccountingRouteNumber: item.routesAccountingRouteNumber,
                        routesAccountingWagonsPerRouteQuantity: item.routesAccountingWagonsPerRouteQuantity,
                        wagonTypes: item.wagonTypes,
                        wagonSpecies: item.wagonSpecies,
                        loadingRestriction: item.loadingRestriction,

                    })
                    break;
                default:
                    break;
            }

            const response = await fetch(endPoint, {
                method: "post",
                body: body,
                headers: getDefaultHeaders(props)
            })
            .catch(console.error)
            if(response === undefined || response === 'undefined'){
            }else{
                const json = await response.json()
                if(json.hasOwnProperty('message') === true){
                    let tmp = JSON.stringify({title: 'Помилка при копіюванні лоту аукціону ', message: JSON.stringify(json)})
                    props.setUniversalError(tmp)

                }else{
                    if(item.auctionRestriction !== null){
                        if(item.auctionRestriction.length > 0){
                            for(let mi = 0; mi < item.auctionRestriction.length; mi++){
                                createRestrictLoadUnload(props, auctionId, json.id, item.auctionRestriction[mi])
                            }
                        }
                    }
                }
            }
        }
    }
}

async function createRestrictLoadUnload(props, auctionId, itemId, item){
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/item/${itemId}/restriction`
    await fetch(endPoint, {
        method: "POST",
        body: JSON.stringify({
            loadObject: item.loadObject,
            loadObjectCode: item.loadObjectCode,
            loadObjectName: item.loadObjectName,
            unloadObject: item.unloadObject,
            unloadObjectCode: item.unloadObjectCode,
            unloadObjectName: item.unloadObjectName
        }),
        headers: getDefaultHeaders(props)
    }).catch(console.error);
}

async function editAuc(props, aucId=null){
    let endPoint;
    if(aucId === null){
        endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/auction/${props.auctionsMy.id}`
    }else{
        endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/auction/${aucId}`
    }
    let tmpDocumentationValue = null;
    let tmpGeologivDataValue = null;
    let tmpGuarantee;
    let tmpMinStep;
    let tmpValue;
    switch(props.auctionsMy.sellingMethod){
        case "renewables":
        case "renewables-fast":
        case "renewables-fast-manual":
        case "renewables-initial-auction":
        case "renewables-initial-qualification":
        case "renewables-initial-qualification-fast":
            tmpGuarantee = {
                currency: 'EUR',
                amount: Number(props.auctionsMy.guarantee.amount),
            }
            tmpMinStep = {
                currency: 'EUR',
                amount: Number(props.auctionsMy.minimalStep.amount),
            }
            tmpValue = {
                currency: 'eurocent',
                amount: Number(props.auctionsMy.value.amount),
            }
            break;
        case "subsoil-english":
        case "subsoil-english-fast":
        case "subsoil-english-fast-manual":
        case "subsoil-english-initial-auction":
        case "subsoil-english-initial-qualification":
        case "subsoil-dutch":
        case "subsoil-dutch-fast":
        case "subsoil-dutch-fast-manual":
        case "subsoil-dutch-initial-auction":
        case "subsoil-dutch-initial-qualification":
        case "subsoil-dutch-initial-auction-manual":
        case "subsoil-english-fast-auction-manual-qualification":
            tmpGuarantee = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.guarantee.amount),
            }
            tmpMinStep = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.minimalStep.amount),
            }
            tmpValue = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.value.amount),
            }
            break;
        case "timber-english":
        case "timber-english-fast":
        case "timber-english-fast-manual":
        case "timber-english-initial-auction":
        case "timber-english-initial-qualification":
        case "timber-english-initial-qualification-fast":
        case "railwayCargo-english":
        case "railwayCargo-english-fast":
        case "railwayCargo-english-fast-manual":
        case "railwayCargo-english-initial-auction":
        case "railwayCargo-english-initial-qualification":
        case "railwayCargo-dutch":
        case "railwayCargo-dutch-fast":
        case "railwayCargo-dutch-fast-manual":
        case "railwayCargo-dutch-initial-auction":
        case "railwayCargo-dutch-initial-qualification":
        case "railwayCargo-dutch-fast-auction-manual-qualification":
        case "railwayCargo-dutch-initial-auction-manual":
        case "dgf-english":
        case "dgf-english-fast":
        case "dgf-english-fast-manual":
        case "dgf-english-fast-auction-manual-qualification":
        case "dgf-english-initial-auction":
        case "dgf-english-initial-auction-manual":
        case "dgf-english-initial-qualification":
        case "dgf-dutch":
        case "dgf-dutch-fast":
        case "dgf-dutch-fast-manual":
        case "dgf-dutch-fast-auction-manual-qualification":
        case "dgf-dutch-initial-auction":
        case "dgf-dutch-initial-qualification":
        case "dgf-dutch-initial-auction-manual":
        case "legitimatePropertyLease-english":
        case "legitimatePropertyLease-english-fast":
        case "legitimatePropertyLease-english-fast-manual":
        case "legitimatePropertyLease-english-fast-auction-manual-qualification":
        case "legitimatePropertyLease-english-initial-auction":
        case "legitimatePropertyLease-english-initial-auction-manual":
        case "legitimatePropertyLease-english-initial-qualification":
        case "legitimatePropertyLease-english-initial-qualification-prod":
        case "legitimatePropertyLease-dutch":
        case "legitimatePropertyLease-dutch-fast":
        case "legitimatePropertyLease-dutch-fast-manual":
        case "legitimatePropertyLease-dutch-fast-auction-manual-qualification":
        case "legitimatePropertyLease-dutch-initial-auction":
        case "legitimatePropertyLease-dutch-initial-auction-manual":
        case "legitimatePropertyLease-dutch-initial-qualification-prod":
        case "legitimatePropertyLease-priorityEnglish":
        case "legitimatePropertyLease-priorityEnglish-fast":
        case "legitimatePropertyLease-priorityEnglish-fast-manual":
        case "legitimatePropertyLease-priorityEnglish-fast-auction-manual-qualification":
        case "legitimatePropertyLease-priorityEnglish-initial-auction":
        case "legitimatePropertyLease-priorityEnglish-initial-auction-manual":
        case "legitimatePropertyLease-priorityEnglish-initial-qualification":
        case "legitimatePropertyLease-priorityEnglish-initial-qualification-prod":
            tmpGuarantee = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.guarantee.amount),
                
            }
            tmpMinStep = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.minimalStep.amount),
                
            }
            tmpValue = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.value.amount),
                valueAddedTaxIncluded: props.auctionsMy.value.valueAddedTaxIncluded,
            }
            break
        default:
            break;
    }

    let tmpCarryType = null;
    if(
        props.auctionsMy.sellingMethod === "railwayCargo-english" ||
        props.auctionsMy.sellingMethod === "railwayCargo-english-fast" ||
        props.auctionsMy.sellingMethod === "railwayCargo-english-fast-manual" ||
        props.auctionsMy.sellingMethod === "railwayCargo-english-initial-auction" ||
        props.auctionsMy.sellingMethod === "railwayCargo-english-initial-qualification" ||
        props.auctionsMy.sellingMethod === "railwayCargo-dutch" ||
        props.auctionsMy.sellingMethod === "railwayCargo-dutch-fast" ||
        props.auctionsMy.sellingMethod === "railwayCargo-dutch-fast-manual" ||
        props.auctionsMy.sellingMethod === "railwayCargo-dutch-initial-auction" ||
        props.auctionsMy.sellingMethod === "railwayCargo-dutch-initial-qualification" ||
        props.auctionsMy.sellingMethod === "railwayCargo-dutch-fast-auction-manual-qualification" ||
        props.auctionsMy.sellingMethod === "railwayCargo-dutch-initial-auction-manual"
    ){
        if(props.auctionsMy.carryType !== null) {tmpCarryType = props.auctionsMy.carryType}
    }

    let minNumberOfQualifiedBids = returnDataRailway(props)
    if(minNumberOfQualifiedBids === 'null') minNumberOfQualifiedBids = null
    

    /////////////////////////////////////////////
    /////////////////////////////////////////////
    let tmpBody
    let tmpValueAddedTaxIncluded1
    if(props.auctionsMy.value.valueAddedTaxIncluded === 'false'){
        tmpValueAddedTaxIncluded1 = false
    }else{
        tmpValueAddedTaxIncluded1 = true
    }
    if(Number(props.auctionsMy.tenderAttempts) !== 1){
        tmpBody = {}
        if(
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast-auction-manual-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-auction" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-auction-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-qualification-prod"
        ){
            if(props.auctionsMy.currentTenantGuaranteeFee.amount !== ''){
                tmpBody.currentTenantGuaranteeFee = {
                    currency: 'UAH',
                    amount: Number(props.auctionsMy.currentTenantGuaranteeFee.amount)
                }
            }
        }
        if(aucId === null){
            tmpBody.documentationValue = props.auctionsMy.documentationValue
            tmpBody.geologicDataValue = props.auctionsMy.geologicDataValue
        }
        tmpBody.leaseDuration = props.auctionsMy.leaseDuration
        let texttmpCarryType = typeof tmpCarryType
        if(texttmpCarryType === 'string'){
            for(let tmI = 0; tmI < props.carryType.length; tmI++){
                if(tmpCarryType === props.carryType[tmI].name){
                    tmpBody.carryType = tmpCarryType
                }
            }
        }else if(texttmpCarryType === 'object'){
            tmpBody.carryType = tmpCarryType.name
        }
        tmpBody.previousAuctionId = props.discount.previousAuctionId
        tmpBody.title = props.auctionsMy.title
        tmpBody.description = props.auctionsMy.description
        if(
            props.auctionsMy.sellingMethod !== "subsoil-english" &&
            props.auctionsMy.sellingMethod !== "subsoil-english-fast" &&
            props.auctionsMy.sellingMethod !== "subsoil-english-fast-manual" &&
            props.auctionsMy.sellingMethod !== "subsoil-english-initial-auction" &&
            props.auctionsMy.sellingMethod !== "subsoil-english-initial-qualification" &&
            props.auctionsMy.sellingMethod !== "subsoil-dutch" &&
            props.auctionsMy.sellingMethod !== "subsoil-dutch-fast" &&
            props.auctionsMy.sellingMethod !== "subsoil-dutch-fast-manual" &&
            props.auctionsMy.sellingMethod !== "subsoil-dutch-initial-auction" &&
            props.auctionsMy.sellingMethod !== "subsoil-dutch-initial-qualification" &&
            props.auctionsMy.sellingMethod !== "subsoil-dutch-initial-auction-manual" &&
            props.auctionsMy.sellingMethod !== "subsoil-english-fast-auction-manual-qualification"
        ){
            tmpBody.bankAccountIds = createArrBanks(props, 1, props.auctionsMy.id)
        }
        tmpBody.sellingMethod = props.auctionsMy.sellingMethod
        tmpBody.tenderAttempts = props.auctionsMy.tenderAttempts
        if(props.auctionsMy.accessDetails !== null && props.auctionsMy.accessDetails !== ''){
            tmpBody.accessDetails = props.auctionsMy.accessDetails
        }
        if(
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-fast" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-fast-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-fast-auction-manual-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-auction" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-auction-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-qualification-prod" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-fast" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-fast-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-fast-auction-manual-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-initial-auction" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-initial-auction-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-initial-qualification-prod" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast-auction-manual-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-auction" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-auction-manual" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-qualification" ||
            props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-qualification-prod"
        ){
            tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
        }else{
            tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
            if(props.auctionsMy.xDocumentRequirements !== null && props.auctionsMy.xDocumentRequirements !== ''){
                tmpBody.xDocumentRequirements = props.auctionsMy.xDocumentRequirements
            }
        }
        if(props.auctionsMy.xAdditionalInformation !== null && props.auctionsMy.xAdditionalInformation !== ''){
            tmpBody.xAdditionalInformation = props.auctionsMy.xAdditionalInformation
        }
        tmpBody.value = {
            currency: 'UAH',
            amount: Number(props.auctionsMy.value.amount),
            valueAddedTaxIncluded: tmpValueAddedTaxIncluded1,
        }
        tmpBody.guarantee = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.guarantee.amount),
        }
        tmpBody.minNumberOfQualifiedBids = minNumberOfQualifiedBids
        tmpBody.minimalStep = {
            currency: 'UAH',
            amount: Number(props.auctionsMy.minimalStep.amount),
        }
        tmpBody.startDate = props.auctionsMy.startDate
        tmpBody.documents = props.auctionsMy.documents

    }else{
        if(props.auctionsMy.status !== null){
            tmpBody = {}
            if(aucId === null){
                tmpBody.documentationValue = props.auctionsMy.documentationValue
                tmpBody.geologicDataValue = props.auctionsMy.geologicDataValue
            }
            tmpBody.leaseDuration = props.auctionsMy.leaseDuration
            let texttmpCarryType = typeof tmpCarryType
            if(texttmpCarryType === 'string'){
                for(let tmI = 0; tmI < props.carryType.length; tmI++){
                    if(tmpCarryType === props.carryType[tmI].name){
                        tmpBody.carryType = tmpCarryType
                    }
                }
            }else if(texttmpCarryType === 'object'){
                tmpBody.carryType = tmpCarryType.name
            }
            tmpBody.title = props.auctionsMy.title
            tmpBody.description = props.auctionsMy.description
            if (procedure.isSUE(props.auctionsMy.sellingMethod) || procedure.isSUD(props.auctionsMy.sellingMethod)) {
                tmpBody.bankAccountIds = createArrBanks(props, 1, props.auctionsMy.id)
            }
            tmpBody.sellingMethod = props.auctionsMy.sellingMethod
            tmpBody.tenderAttempts = props.auctionsMy.tenderAttempts
            if(props.auctionsMy.accessDetails !== null && props.auctionsMy.accessDetails !== ''){
                tmpBody.accessDetails = props.auctionsMy.accessDetails
            }
            if (procedure.isLLE(props.auctionsMy.sellingMethod)
                || procedure.isLLD(props.auctionsMy.sellingMethod)
                || procedure.isLLP(props.auctionsMy.sellingMethod)
            ) {
                tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
            }else{
                tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
                if(props.auctionsMy.xDocumentRequirements !== null && props.auctionsMy.xDocumentRequirements !== ''){
                    tmpBody.xDocumentRequirements = props.auctionsMy.xDocumentRequirements
                }
            }
            if(props.auctionsMy.xAdditionalInformation !== null && props.auctionsMy.xAdditionalInformation !== ''){
                tmpBody.xAdditionalInformation = props.auctionsMy.xAdditionalInformation
            }
            tmpBody.value = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.value.amount),
                valueAddedTaxIncluded: tmpValueAddedTaxIncluded1,
            }
            tmpBody.guarantee = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.guarantee.amount),
            }
            tmpBody.minNumberOfQualifiedBids = minNumberOfQualifiedBids
            tmpBody.minimalStep = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.minimalStep.amount),
            }
            tmpBody.startDate = props.auctionsMy.startDate
            tmpBody.documents = props.auctionsMy.documents
        }else{
            tmpBody = {}
            if(aucId === null){
                tmpBody.documentationValue = props.auctionsMy.documentationValue
                tmpBody.geologicDataValue = props.auctionsMy.geologicDataValue
            }
            tmpBody.leaseDuration = props.auctionsMy.leaseDuration
            let texttmpCarryType = typeof tmpCarryType
            if(texttmpCarryType === 'string'){
                for(let tmI = 0; tmI < props.carryType.length; tmI++){
                    if(tmpCarryType === props.carryType[tmI].name){
                        tmpBody.carryType = tmpCarryType
                    }
                }
            }else if(texttmpCarryType === 'object'){
                tmpBody.carryType = tmpCarryType.name
            }
            tmpBody.previousAuctionId = null
            tmpBody.title = props.auctionsMy.title
            tmpBody.description = props.auctionsMy.description
            if(
                props.auctionsMy.sellingMethod !== "subsoil-english" &&
                props.auctionsMy.sellingMethod !== "subsoil-english-fast" &&
                props.auctionsMy.sellingMethod !== "subsoil-english-fast-manual" &&
                props.auctionsMy.sellingMethod !== "subsoil-english-initial-auction" &&
                props.auctionsMy.sellingMethod !== "subsoil-english-initial-qualification" &&
                props.auctionsMy.sellingMethod !== "subsoil-dutch" &&
                props.auctionsMy.sellingMethod !== "subsoil-dutch-fast" &&
                props.auctionsMy.sellingMethod !== "subsoil-dutch-fast-manual" &&
                props.auctionsMy.sellingMethod !== "subsoil-dutch-initial-auction" &&
                props.auctionsMy.sellingMethod !== "subsoil-dutch-initial-qualification" &&
                props.auctionsMy.sellingMethod !== "subsoil-dutch-initial-auction-manual" &&
                props.auctionsMy.sellingMethod !== "subsoil-english-fast-auction-manual-qualification"
            ){
                tmpBody.bankAccountIds = createArrBanks(props, 1, props.auctionsMy.id)
            }
            tmpBody.sellingMethod = props.auctionsMy.sellingMethod
            tmpBody.tenderAttempts = props.auctionsMy.tenderAttempts
            if(props.auctionsMy.accessDetails !== null && props.auctionsMy.accessDetails !== ''){
                tmpBody.accessDetails = props.auctionsMy.accessDetails
            }
            if(
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-english" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-fast" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-fast-manual" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-fast-auction-manual-qualification" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-auction" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-auction-manual" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-qualification" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-english-initial-qualification-prod" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-fast" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-fast-manual" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-fast-auction-manual-qualification" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-initial-auction" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-initial-auction-manual" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-dutch-initial-qualification-prod" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast-manual" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-fast-auction-manual-qualification" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-auction" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-auction-manual" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-qualification" ||
                props.auctionsMy.sellingMethod === "legitimatePropertyLease-priorityEnglish-initial-qualification-prod"
            ){
                tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
            }else{
                tmpBody.lotIdentifier = props.auctionsMy.lotIdentifier
                if(props.auctionsMy.xDocumentRequirements !== null && props.auctionsMy.xDocumentRequirements !== ''){
                    tmpBody.xDocumentRequirements = props.auctionsMy.xDocumentRequirements
                }
            }
            if(props.auctionsMy.xAdditionalInformation !== null && props.auctionsMy.xAdditionalInformation !== ''){
                tmpBody.xAdditionalInformation = props.auctionsMy.xAdditionalInformation
            }
            tmpBody.value = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.value.amount),
                valueAddedTaxIncluded: tmpValueAddedTaxIncluded1,
            }
            tmpBody.guarantee = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.guarantee.amount),
            }
            tmpBody.minNumberOfQualifiedBids = minNumberOfQualifiedBids
            tmpBody.minimalStep = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.minimalStep.amount),
            }
            tmpBody.startDate = props.auctionsMy.startDate
            tmpBody.documents = props.auctionsMy.documents
        }
    }
    /////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////
    if(aucId === null){
        if(Number(props.auctionsMy.tenderAttempts) === 1){
            if(props.auctionsMy.discount !== null){
                await deleteDiscount(props, props.auctionsMy.id)
            }
        }
    }

    switch(props.auctionsMy.sellingMethod){
        case "dgf-english":
        case "dgf-english-fast":
        case "dgf-english-fast-manual":
        case "dgf-english-fast-auction-manual-qualification":
        case "dgf-english-initial-auction":
        case "dgf-english-initial-auction-manual":
        case "dgf-english-initial-qualification":
        case "dgf-dutch":
        case "dgf-dutch-fast":
        case "dgf-dutch-fast-manual":
        case "dgf-dutch-fast-auction-manual-qualification":
        case "dgf-dutch-initial-auction":
        case "dgf-dutch-initial-qualification":
        case "dgf-dutch-initial-auction-manual":
            tmpBody.minNumberOfQualifiedBids = Number(props.auctionsMy.minNumberOfQualifiedBids)
            tmpBody.virtualDataRoom = props.auctionsMy.virtualDataRoom
            tmpBody.eligibilityCriteria = props.auctionsMy.eligibilityCriteria
            tmpBody.decision = {
                decisionId: props.auctionsMy.decision.decisionId,
                decisionDate: props.auctionsMy.decision.decisionDate
            }
            tmpBody.x_dgfPlatformLegalDetails = props.auctionsMy.x_dgfPlatformLegalDetails
            break;
        case "legitimatePropertyLease-english":
        case "legitimatePropertyLease-english-fast":
        case "legitimatePropertyLease-english-fast-manual":
        case "legitimatePropertyLease-english-fast-auction-manual-qualification":
        case "legitimatePropertyLease-english-initial-auction":
        case "legitimatePropertyLease-english-initial-auction-manual":
        case "legitimatePropertyLease-english-initial-qualification":
        case "legitimatePropertyLease-english-initial-qualification-prod":
        case "legitimatePropertyLease-dutch":
        case "legitimatePropertyLease-dutch-fast":
        case "legitimatePropertyLease-dutch-fast-manual":
        case "legitimatePropertyLease-dutch-fast-auction-manual-qualification":
        case "legitimatePropertyLease-dutch-initial-auction":
        case "legitimatePropertyLease-dutch-initial-auction-manual":
        case "legitimatePropertyLease-dutch-initial-qualification-prod":
        case "legitimatePropertyLease-priorityEnglish":
        case "legitimatePropertyLease-priorityEnglish-fast":
        case "legitimatePropertyLease-priorityEnglish-fast-manual":
        case "legitimatePropertyLease-priorityEnglish-fast-auction-manual-qualification":
        case "legitimatePropertyLease-priorityEnglish-initial-auction":
        case "legitimatePropertyLease-priorityEnglish-initial-auction-manual":
        case "legitimatePropertyLease-priorityEnglish-initial-qualification":
        case "legitimatePropertyLease-priorityEnglish-initial-qualification-prod":
            if(Number(props.auctionsMy.minNumberOfQualifiedBids) === 1 || Number(props.auctionsMy.minNumberOfQualifiedBids) === 2){
                tmpBody.minNumberOfQualifiedBids = Number(props.auctionsMy.minNumberOfQualifiedBids)
            }else{
                tmpBody.minNumberOfQualifiedBids = 1
            }
            tmpBody.calcOnBookValue = props.auctionsMy.calcOnBookValue
            tmpBody.valueAddedTaxCharged = props.auctionsMy.valueAddedTaxCharged
            tmpBody.registryId = props.auctionsMy.registryId
            if(props.auctionsMy.registrationFee.valueAddedTaxIncluded === true || props.auctionsMy.registrationFee.valueAddedTaxIncluded === 'true'){
                tmpBody.registrationFee = {
                    currency: 'UAH',
                    amount: Number(props.auctionsMy.registrationFee.amount),
                    valueAddedTaxIncluded: true
                }
            }else if(props.auctionsMy.registrationFee.valueAddedTaxIncluded === false || props.auctionsMy.registrationFee.valueAddedTaxIncluded === 'false'){
                tmpBody.registrationFee = {
                    currency: 'UAH',
                    amount: Number(props.auctionsMy.registrationFee.amount),
                    valueAddedTaxIncluded: false
                }
            }else{
                tmpBody.registrationFee = {
                    currency: 'UAH',
                    amount: Number(props.auctionsMy.registrationFee.amount),
                }
            }
            tmpBody.valuePeriod = props.auctionsMy.valuePeriod
            break;
        default:
            break;
    }

    if (props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish")) {
        if(props.auctionsMy.currentTenantGuaranteeFee.amount !== ''){
            tmpBody.currentTenantGuaranteeFee = {
                currency: 'UAH',
                amount: Number(props.auctionsMy.currentTenantGuaranteeFee.amount)
            }
        }
    }


    if (props.auctionsMy.sellingMethod.startsWith('landSell-priorityEnglish')) {
        if(props.auctionsMy.numberOfCurrentTenants !== 'null' && props.auctionsMy.numberOfCurrentTenants !== null){
            tmpBody.numberOfCurrentTenants = props.auctionsMy.numberOfCurrentTenants
            if(props.auctionsMy.currentTenants.identifier.scheme === 'null'){
                tmpBody.currentTenants = null
            }else{
                tmpBody.currentTenants = props.auctionsMy.currentTenants
            }
        }else{
            tmpBody.numberOfCurrentTenants = 1
            if(props.auctionsMy.currentTenants.identifier.scheme === 'null'){
                tmpBody.currentTenants = null
            }else{
                tmpBody.currentTenants = props.auctionsMy.currentTenants
            }
        }
    }

    const response = await fetch(endPoint, {
        method: "PUT",
        body: JSON.stringify(tmpBody),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: 'Помилка при редагуванні аукціону', message: JSON.stringify(json)})
            props.setUniversalError(tmp)
        }else{
            if(
                props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-english") ||
                props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-dutch") ||
                props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish")
            ){
                if(aucId === null){
                    createArrBanks(props, 2, props.auctionsMy.id)
                    createAuctionLeaseRules(props, json.id)
                }else{
                    createArrBanks(props, 2, aucId)
                    createAuctionLeaseRules(props, json.id)
                }
            }
            if(aucId === null){
                if(props.discount.discountOnOff === true){
                    if(props.discount.id === null){
                        createDiscountForAuction(props, props.auctionsMy.id)
                    }else{
                        editDiscountForAuction(props, props.auctionsMy.id)
                    }
                }
            }else{
                if(props.discount.discountOnOff === true){
                    if(props.discount.id === null){
                        createDiscountForAuction(props, aucId)
                    }else{
                        editDiscountForAuction(props, aucId)
                    }
                }
            }
            if(dutchData(props) !== false){
                let dutchStep = {
                    dutchStepQuantity: props.auctionsMy.dutchStep.dutchStepQuantity,
                    dutchStepPercent: props.auctionsMy.dutchStep.dutchStepPercent,
                    dutchStepValue: {
                        currency: 'UAH',
                        amount: props.auctionsMy.dutchStep.dutchStepValue.amount,
                    },
                }
                const endPoint3 = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${json.id}/dutch_step`
                const response3 = await fetch(endPoint3, {
                    method: "PUT",
                    body: JSON.stringify(dutchStep),
                    headers: getDefaultHeaders(props)
                }).catch(console.error)
                if(response3 === undefined || response3 === 'undefined'){
                }else{
                    const json3 = await response3.json()
                    if(json3.hasOwnProperty('message') === true){
                        let tmp = JSON.stringify({title: 'Помилка при редагуванні аукціону', message: JSON.stringify(json3)})
                        props.setUniversalError(tmp)
                        props.setPopUpAuctionCreate(1)
                    }else{
                        let tmpAucData = json
                        tmpAucData.dutchStep = json3
                        props.setPopUpAuctionCreate(tmpAucData)
                    }
                }
            }else{
                props.setPopUpAuctionCreate(json)
            }
        }
    }
    props.setBankAccountAdd([])
    props.setBankAccountDelete([])
    props.changeLoader(false)
}

async function deleteDiscount(props, auctionId){
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${auctionId}/discount`
    const response = await fetch(endPoint, {
        method: "DELETE",
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: 'Помилка при видаленні знижки', message: JSON.stringify(json)})
            props.setUniversalError(tmp)
        }
    }
}

function createArrBanks(props, type, aucId){
    if(
        props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-english") ||
        props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-dutch") ||
        props.auctionsMy.sellingMethod.startsWith("legitimatePropertyLease-priorityEnglish")
    ){
        if(type === 2){
            createZUBanks(props, aucId)
        }
    }else{
        if(
            props.auctionsMy.sellingMethod.startsWith("subsoil-english") ||
            props.auctionsMy.sellingMethod.startsWith("subsoil-dutch")
        ){
            let tmp = []
            for(let i = 0; i < props.auctionsMy.bankAccounts.length; i++){
                if(props.bankAccountWork.deleteBank.includes(String(props.auctionsMy.bankAccounts[i].id)) === false) tmp.push(props.auctionsMy.bankAccounts[i].id)
            }
            for(let i = 0; i < props.bankAccountWork.addNewBank.length; i++){
                tmp.push(Number(props.bankAccountWork.addNewBank[i]))
            }
            return tmp
        }
    }
}

//
async function createAuctionLeaseRules(props, aucId){
    let body = {}
    body.intendedUseRestrictionMethod = props.auctionsMy.leaseRules.intendedUseRestrictionMethod
    body.intendedUseRestrictionDescription = props.auctionsMy.leaseRules.intendedUseRestrictionDescription
    body.additionalLeaseConditions = props.auctionsMy.leaseRules.additionalLeaseConditions
    body.subleaseAllowed = props.auctionsMy.leaseRules.subleaseAllowed
            if(props?.auctionsMy?.leaseRules?.intendedUseRestrictionMethod === 'exceptDescribed'){
                body.intendedUse = props.auctionsMy.leaseRules.intendedUse
            }

    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${aucId}/lease_rules`
    const response = await fetch(endPoint, {
        method: "POST",
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: "Помилка при створенні Тип переліку, до якого віднесено об'єкт", message: JSON.stringify(json)})
            props.setUniversalError(tmp)
        }else{
            await createAuctionLeaseRulesShedule(props, aucId)
                    if(props.shedullePeriod.newFullPeriod.length > 0){
                        for(let it=0; it < props.shedullePeriod.newFullPeriod.length; it++){
                            await createAuctionLeaseRulesShedulePeriod(props, aucId, props.shedullePeriod.newFullPeriod[it])
                        }
                    }
            await createAuctionRelatedOrganizations(props, aucId)
        }
    }
}

async function createAuctionLeaseRulesShedule(props, aucId){
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${aucId}/lease_rules/schedule`
    let body = {}
    if(
        props.schedule.hoursBy.by !== 'null' &&
        props.schedule.hoursBy.by !== null &&
        props.schedule.hoursBy.value !== '' &&
        props.schedule.hoursBy.value !== null
    ){
        body.hoursBy = {
            value: props.schedule.hoursBy.value,
            by: props.schedule.hoursBy.by
        }
    }else{
        body.hoursBy = {}
    }
    if(
        props.schedule.daysBy.by !== 'null' &&
        props.schedule.daysBy.by !== null &&
        props.schedule.daysBy.value !== '' &&
        props.schedule.daysBy.value !== null
    ){
        body.daysBy = {
            value: props.schedule.daysBy.value,
            by: props.schedule.daysBy.by
        }
    }else{
        body.daysBy = {}
    }
    if(props.schedule.daysBy.value === '' || props.schedule.daysBy.value === null){
        if(props.schedule.hoursBy.value === '' || props.schedule.hoursBy.value === null){
            body.other = props.schedule.other
        }
    }
    const response = await fetch(endPoint, {
        method: "POST",
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: "Помилка при створенні розкладу", message: JSON.stringify(json)})
            props.setUniversalError(tmp)
        }
    }
}

//Периоды
async function createAuctionLeaseRulesShedulePeriod(props, aucId, data){
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${aucId}/lease_rules/schedule/period`
    let body = {}
    if(data.timeStart !== ''){
        let tmp = data.timeStart.split('/');
        body.startDate = tmp[2] + '-' + tmp[1] + '-' + tmp[0] + 'T00:00:00+00:00'
    }
    if(data.timeEnd !== ''){
        let tmp = data.timeEnd.split('/');
        body.endDate = tmp[2] + '-' + tmp[1] + '-' + tmp[0] + 'T00:00:00+00:00'
    }
    if(data.weekdays.length > 0){
        body.weekdays = data.weekdays
    }
    const response = await fetch(endPoint, {
        method: "POST",
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: "Помилка при створенні періодов", message: JSON.stringify(json)})
            props.setUniversalError(tmp)
        }
    }
    await props.setDataAddress([], 'SET_NEW_FULL_PERIOD_ARR')
}

async function createAuctionRelatedOrganizations(props, aucId){
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/auction/${aucId}/related_organizations`
    let body = {}
    if(props.auctionsMy.relatedOrganizations.propertyOwner !== null){
        if(props.auctionsMy.relatedOrganizations.propertyOwner.id !== 'null') body.propertyOwnerId = Number(props.auctionsMy.relatedOrganizations.propertyOwner.id)
    }
    if(props.auctionsMy.relatedOrganizations.sellingEntity !== null){
        if(props.auctionsMy.relatedOrganizations.sellingEntity.id !== 'null') body.sellingEntityId = Number(props.auctionsMy.relatedOrganizations.sellingEntity.id)
    }
    if(props.auctionsMy.relatedOrganizations.currentTenant !== null){
        if(props.auctionsMy.relatedOrganizations.currentTenant.id !== 'null') body.currentTenantId = Number(props.auctionsMy.relatedOrganizations.currentTenant.id)
    }
    if(props.auctionsMy.relatedOrganizations.ownershipType !== '') body.ownershipType = props.auctionsMy.relatedOrganizations.ownershipType
    const response = await fetch(endPoint, {
        method: "POST",
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: "Помилка при створенні relatedOrganizations", message: JSON.stringify(json)})
            props.setUniversalError(tmp)
        }
    }
}

async function createZUBanks(props, aucId){
    let tmpRregistrationFee = [],
        tmpGuarantee = [],
        tmpSecurityDeposit = [],
        tmpImprovementCompensation = [],
        tmpOther = [],
        tmpAdvancePayment = [],
        tmpLease = []

    for(let i=0; i < props.bankAccountZU.length; i++){
        if(props.bankAccountZU[i].groupe === 'registrationFee'){
            tmpRregistrationFee.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'guarantee'){
            tmpGuarantee.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'securityDeposit'){
            tmpSecurityDeposit.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'improvementCompensation'){
            tmpImprovementCompensation.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'other'){
            tmpOther.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'advancePayment'){
            tmpAdvancePayment.push(props.bankAccountZU[i])
        }else if(props.bankAccountZU[i].groupe === 'lease'){
            tmpLease.push(props.bankAccountZU[i])
        }
    }
    if(tmpRregistrationFee.length > 0){
        let data = {}
        for(let i=0; i < tmpRregistrationFee.length; i++){
            data.id = Number(tmpRregistrationFee[i].id)
            data.groupe = "registrationFee"
            await createZUBanksPOST(props, data, aucId)
        }
    }
    if(tmpGuarantee.length > 0){
        let data = {}
        for(let i=0; i < tmpGuarantee.length; i++){
            data.id = Number(tmpGuarantee[i].id)
            data.groupe = "guarantee"
            await createZUBanksPOST(props, data, aucId)
        }
    }
    if(tmpSecurityDeposit.length > 0){
        let data = {}
        for(let i=0; i < tmpSecurityDeposit.length; i++){
            data.id = Number(tmpSecurityDeposit[i].id)
            data.groupe = "securityDeposit"
            await createZUBanksPOST(props, data, aucId)
        }
    }
    if(tmpImprovementCompensation.length > 0){
        let data = {}
        for(let i=0; i < tmpImprovementCompensation.length; i++){
            data.id = Number(tmpImprovementCompensation[i].id)
            data.groupe = "improvementCompensation"
            await createZUBanksPOST(props, data, aucId)
        }
    }
    if(tmpOther.length > 0){
        let data = {}
        for(let i=0; i < tmpOther.length; i++){
            data.id = Number(tmpOther[i].id)
            data.groupe = "other"
            await createZUBanksPOST(props, data, aucId)
        }
    }
    if(tmpAdvancePayment.length > 0){
        let data = {}
        for(let i=0; i < tmpAdvancePayment.length; i++){
            data.id = Number(tmpAdvancePayment[i].id)
            data.groupe = "advancePayment"
            if(tmpAdvancePayment[i].percent !== ''){
                data.percent = tmpAdvancePayment[i].percent
            }
            if(tmpAdvancePayment[i].holderType !== 'null'){
                data.holderType = tmpAdvancePayment[i].holderType
            }
            await createZUBanksPOST(props, data, aucId)
        }
    }
    if(tmpLease.length > 0){
        let data = {}
        for(let i=0; i < tmpLease.length; i++){
            data.id = Number(tmpLease[i].id)
            data.groupe = "lease"
            if(tmpLease[i].percent !== ''){
                data.percent = tmpLease[i].percent
            }
            if(tmpLease[i].holderType !== 'null'){
                data.holderType = tmpLease[i].holderType
            }
            await createZUBanksPOST(props, data, aucId)
        }
    }
    await clearBanks(props)
}

async function clearBanks(props){
    await addArrayBankAccountsClear(props)
    await addBankAccountZUtimestamp(props)
}

async function createZUBanksPOST(props, data, aucId){
    let body = {}
    body.bankAccountIds = data.id
    if(
        data.groupe === 'advancePayment' ||
        data.groupe === 'lease'
    ){
        if(data.holderType !== 'null') body.holderType = data.holderType
        if(data.percent !== '') body.percent = data.percent
    }
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/auction/${aucId}/bank_account_groups/${data.groupe}`
    const response = await fetch(endPoint, {
        method: "POST",
        body: JSON.stringify(body),
        headers: getDefaultHeaders(props)
    }).catch(console.error)
    if(response === undefined || response === 'undefined'){
    }else{
        const json = await response.json()
        if(json.hasOwnProperty('message') === true){
            let tmp = JSON.stringify({title: "Помилка при створенні Тип переліку, до якого віднесено об'єкт", message: JSON.stringify(json)})
            props.setUniversalError(tmp)
        }else{
            await addArrayBankAccountsClear(props)
            await addBankAccountZUtimestamp(props)
        }
    }
}

async function addArrayBankAccountsClear(props){
    props.setDataAddress([], 'SET_POP_UP_BANK_ACCOUNT_ZU')
}
async function addBankAccountZUtimestamp(props){
    let tmp = new Date()
    props.setDataAddress(String(tmp), 'SET_POP_UP_BANK_ACCOUNT_ZU_TIMESTAMP')
}

const mapStateToProps = state => {
    return {
        token: state.start.token,
        auctions: state.start.auctionsGet,
        langFlag: state.start.langFlag,
        createAuctionTab: state.start.createAuctionTab,
        createAuction: state.start.createAuction,
        auctionsSwitchWindow: state.start.auctionsSwitchWindow,
        endPoint: state.start.endPoint,
        classificationsGets: state.start.classificationsGet,
        auctionsMy: state.start.auctionsMy,
        bankAccount: state.start.bankAccount,
        bankAccountId: state.start.bankAccountId,
        bankAccountIdArr: state.start.bankAccountIdArr,
        discount: state.start.discount,
        userProfiles: state.start.userProfiles,
        carryType: state.start.carryType,
        bankAccountWork: state.start.bankAccountWork,
        addressNew: state.start.addressNew,
        bankAccountZU: state.start.bankAccountZU,
        createBankAccountZU: state.start.createBankAccountZU,
        schedule: state.start.schedule,
        auctionsZUAttemp: state.start.auctionsZUAttemp,
        shedullePeriod: state.start.shedullePeriod,
        deleteBankGroops: state.start.deleteBankGroops,
        deleteCurentBank: state.start.deleteCurentBank
    }
}

const mapDispatchToProps = {
    changeCreateAuctionTitle,
    changeCreateAuctionDescription,

    changeCreateAuctionType,
    changeCreateAuctionTenderAttempts,
    changeCreateAuctionAccessDetails,
    changeCreateAuctionXDocumentRequirements,
    changeCreateAuctionXAdditionalInformation,
    changeCreateAuctionValueCurrency,
    changeCreateAuctionValueAmount,
    changeCreateAuctionValueTax,
    changeCreateAuctionGuaranteeCurrency,
    changeCreateAuctionGuaranteeAmount,
    changeCreateAuctionGuaranteeTax,
    changeCreateAuctionMinimalStepCurrency,
    changeCreateAuctionMinimalStepAmount,
    changeCreateAuctionMinimalStepTax,
    changeCreateAuctionDateStart,
    changeCreateAuctionDateEnd,

    changeAuctionsSwitchWindow,

    auctionsGetMy,
    getMyAuction,
    changeCreateAuctionLotIdentifier,

    changePopUpBankAccount,
    setPopBankAccountId,
    setPopBankAccountIdArr,
    changeCreateAuctionTab,

    setPopUpAuctionCreate,

    changeCreateItemGeologivDataValue,
    changeCreateItemDocumentationValue,
    changeCreateItemDateUse,
    setCarryType,

    setPopUpAuctionMyNull,

    changeDiscountPercent,
    changeDiscountPreviousAuctionCurrency,
    changeDiscountPreviousAuctionAmount,
    changeDiscountPreviousAuctionId,
    discountAuc,

    minNumberOfQualifiedBids,
    setUniversalError,

    setBankAccountSave,
    setBankAccountAdd,
    setBankAccountDelete,

    changeCreateAuctionMinNumberOfQualifiedBids,
    changeCreateAuctionDgfVirtualDataRoom,
    changeCreateAuctionDgfEligibilityCriteria,
    changeCreateAuctionDgfX_dgfPlatformLegalDetails,
    changeCreateAuctionDgfDecisionId,
    changeCreateAuctionDgfDecisionDate,
    setDataAddress,

    changeLoader,
    openBankWindows,
    bankAccountGet
}

export default connect(mapStateToProps, mapDispatchToProps)(WindowAuction)